import React, {Component} from 'react';
import {action, observable, computed} from 'mobx';
import {inject, observer} from 'mobx-react';
import './style.scss'

// 각 위젯 박스의 "예제 보기" 라이트박스에 사용할 캡처 이미지
import widgetReviewInsight from '../../../assets/widgwt_sample/review_insight.png';
import widgetAiKeyword     from '../../../assets/widgwt_sample/ai_review_keyword.png';
import widgetBoard         from '../../../assets/widgwt_sample/board_review.png';
import widgetWriterQ       from '../../../assets/widgwt_sample/witer_q.png';
import widgetLiveReview    from '../../../assets/widgwt_sample/real_review.png';
import widgetLiveOrder     from '../../../assets/widgwt_sample/real_older_review.png';
import PreviewLightbox from '../../../components/common/PreviewLightbox';
import {
  FormCheckbox,
  FormSelect,
  Modal,
  ModalBody,
  ModalHeader,
  InputGroup,
  InputGroupAddon,
  FormInput,
  Button, InputGroupText
} from "shards-react";
import PageTitle from "../../../components/common/PageTitle";
import FeatherIcon from 'feather-icons-react';
import {ChromePicker} from "react-color";
import {toast} from "react-toastify";
import _ from "underscore";

const selectingProps = [
  {"key" : "newest", "label": "최신순"},
  {"key" : "grade", "label": "평점순"},
  {"key" : "specify", "label": "지정"},
  {"key" : "specify_product", "label": "지정(상품별)"},
];

// 리뷰 인사이트 위젯에서 표시할 만족도 문장 프리셋 (랜덤 1개 선택)
// {p} 는 만족도 퍼센트로 치환
const SATISFACTION_PRESETS = {
  ko: [
    '구매 고객 만족도 {p}%',
    '실제 구매 고객의 {p}%가 만족했어요',
    '고객 만족도 {p}%를 기록한 상품입니다',
    '구매 고객 만족 평가 {p}%',
    '{p}% 고객이 만족한 상품이에요.',
    '구매 후 만족 응답 {p}%',
    '실제 사용 고객 만족도 {p}% 입니다.',
    '이 상품에 만족한 고객 비율 {p}% 입니다.',
    '구매 고객의 {p}%가 만족한 상품입니다.'
  ],
  en: [
    'Customer satisfaction {p}%',
    '{p}% of buyers were satisfied with this product',
    'Rated {p}% in customer satisfaction',
    'Overall satisfaction score: {p}%',
    '{p}% of customers loved this product',
    'Post-purchase satisfaction {p}%',
    'Real-user satisfaction {p}%',
    '{p}% of customers are happy with this item',
    '{p}% of buyers recommend this product'
  ],
  jp: [
    '購入者満足度 {p}%',
    '実際の購入者の {p}% が満足しました',
    '顧客満足度 {p}% を記録した商品です',
    '購入後満足評価 {p}%',
    '{p}% のお客様が満足した商品です',
    '購入後満足度の回答 {p}%',
    '実際の利用者満足度 {p}% です',
    'この商品に満足したお客様の割合 {p}%',
    '購入者の {p}% が満足した商品です'
  ]
};
const DEFAULT_SATISFACTION_SENTENCES = SATISFACTION_PRESETS.ko;

const displayAreaProps = [
  {"key" : "main", "label": "메인(인덱스) 페이지"},
  {"key" : "list", "label": "리스트 페이지(하단)"},
  {"key" : "detail_top", "label": "상세 페이지 상단(해당상품)"},
  {"key" : "detail_top_all", "label": "상세 페이지 상단(전체상품)"},
  {"key" : "board_top", "label": "후기 페이지 상단"},
  // {"key" : "detail_bottom", "label": "상세 페이지 하단"},
  {"key" : "mypage", "label": "마이페이지(주문페이지)"},
  {"key" : "code", "label": "코드로 사용"},
];

const pageTabProps = [
  {"key" : "multi", "label": "다중 페이지", "areas": []},
  // {"key" : "main", "label": "메인", "areas": ["main"]}, // 위젯 박스 없음 — 미노출
  {"key" : "detail", "label": "상품 상세페이지", "areas": ["detail_top", "detail_top_all"]},
  {"key" : "board", "label": "리뷰 게시판", "areas": ["board_top"]},
  {"key" : "mypage", "label": "마이페이지", "areas": ["mypage"]},
];

const colProps = [
  {"key" : 2, "label": 2},
  {"key" : 3, "label": 3},
  {"key" : 4, "label": 4},
  {"key" : 5, "label": 5},
  {"key" : 6, "label": 6},
];

const rowProps = [
  {"key" : 1, "label": 1},
  {"key" : 2, "label": 2},
  {"key" : 3, "label": 3},
];

const booleanProps = [
  {"key" : true, "label": "사용함"},
  {"key" : false, "label": "사용안함"},
];

const booleanDisProps = [
  {"key" : false, "label": "노출안함"},
  {"key" : true, "label": "노출"},
];

const reviewTypeProps = [
  {"key" : "photo", "label": "포토"},
  {"key" : "text", "label": "텍스트"},
  {"key" : "all", "label": "텍스트+포토"},
];

const defaultStyle = {
  marginTop: 30,
  marginBottom: 30,
}

const defaultHeadStyle =  {
  textAlign: 'left',
  color: '#000000',
  size: 23,
  marginTop: 0,
  marginBottom: 30,
  lrPadding:0
}



@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me:teamUser.me }))
@inject(({ widget }) => ({ updateWidget: widget.updateWidget, getWidgetList:widget.getWidgetList, removeWidget:widget.removeWidget }))
@inject(({ common }) => ({ getStoreTotalConfig: common.getStoreTotalConfig, updateDoc: common.updateDoc, getDoc: common.getDoc }))

@observer
class widgetByPage extends Component {

  @observable shopUser = {};
  @observable shopInfo = {};
  @observable emailId = '';
  @observable isLogin = false;

  @observable isShowMColor_1 = false;
  @observable activeTab = 'multi';

  @observable makeWidgetProps = {
    "basic": {label: "일반 리뷰", selecting: selectingProps, displayArea: displayAreaProps, row: rowProps, col: colProps, isAutoPlay: booleanProps, isDisplay: booleanDisProps, isTitleDis: booleanDisProps, reviewType: reviewTypeProps},
    "slider": {label: "슬라이드 리뷰", selecting: selectingProps, displayArea: displayAreaProps, row: rowProps, col: colProps, isAutoPlay: booleanProps, isDisplay: booleanDisProps, isTitleDis: booleanDisProps, reviewType: reviewTypeProps},
    "purchase_review": {label: "실시간 주문", selecting: selectingProps, displayArea: displayAreaProps, isDisplay: booleanDisProps, isTitleDis: booleanDisProps},
    // "analysis": {label: "분석 위젯", selecting: selectingProps, displayArea: displayAreaProps, row: rowProps, col: colProps, isAutoPlay: booleanProps, isDisplay: booleanDisProps},
    // "ai_floating": {label: "AI 분석 위젯", selecting: selectingProps, isAutoPlay: booleanProps, isDisplay: booleanDisProps},
    // "media": {"label": "포토 리뷰", "selecting": selectingProps, "displayArea": displayAreaProps, "row": rowProps, "col": colProps, "isAutoPlay": booleanProps},
    // "movie": {"label": "영상 리뷰", "selecting": selectingProps, "displayArea": displayAreaProps, "row": rowProps, "col": colProps, "isAutoPlay": booleanProps},
    // "reviewList": {"label": "실시간 리뷰 목록 위젯"},
    //"buyAlam": {"label": "구입 알림 위젯"},
    // "reviewAlam": {"label": "리뷰 알림 위젯"},
    // "writableReview": {"label": "리뷰작성유도 위젯"},
  };

  @observable newWidgetProps = this.makeWidgetProps.basic;

  @observable newWidget = {};
  @observable curWidget = {
    style:{ style: defaultStyle },
    head:{ style: defaultHeadStyle },
    display: {
      rating: true,
      count: true
    }
  };

  //list
  @observable listParams = {
    page:1, limit:20,
  }
  @observable list = [];

  @observable metaWidget = {
    store_id: null,
    productMetaType : "no",
    productMetaTypeAlign: "no",
    reviewInsight: "no",
    reviewRatingCount: "no",
    reviewPageType : "both",
    reviewPagePath : "/board/product/list.html?board_no=4, /board/상품-사용후기/4/",
    reviewPageListCount: 5,
    reviewPagePhotoCount: 12,
    reviewPagePhotoTitle: "",
    aiRollingKeyword: "no",
    aiRollingKeywordBg: "theme-0",
    reviewInsightConfig: {
      maxWidth: "100%", marginTop: "30px", marginBottom: "30px", lrPadding: "0px",
      showRating: true, showCount: true, parentSelector: "", insertPosition: "append",
      satisfactionSentences: DEFAULT_SATISFACTION_SENTENCES.slice()
    },
    reviewRatingCountConfig: {
      maxWidth: "100%", marginTop: "0px", marginBottom: "0px", lrPadding: "0px",
      parentSelector: "", insertPosition: "append"
    },
    reviewPageConfig: {
      maxWidth: "100%", marginTop: "0px", marginBottom: "0px", lrPadding: "0px",
      showRating: true, showCount: true, parentSelector: "", insertPosition: "append",
      hideSelector: ""
    },
    // 나의리뷰(마이페이지) 위젯 — 리뷰 페이지와 동일한 설정 구성 + 작성가능 탭/기본탭
    myReview: "no",
    myReviewConfig: {
      title: "나의 리뷰",
      showWritable: true,        // '작성 가능한 리뷰' 탭 노출
      defaultTab: "written",     // 'written'(작성한 리뷰) | 'writable'(작성 가능한 리뷰)
      listCount: 5,
      showRating: true, showCount: true,
      maxWidth: "100%", marginTop: "0px", marginBottom: "0px", lrPadding: "0px",
      parentSelector: "", parentSelectorMobile: "",
      insertPosition: "append", insertPositionMobile: "",
      hideSelector: ""
    },
    productListConfig: {
      marginTop: "0px", marginBottom: "0px", lrPadding: "0px",
      parentSelector: "", insertPosition: "append", productListClass: ""
    },
    reviewableList: "yes",
    reviewableListConfig: {
      pages: [],
      reShowDelay: 24
    },
    realtimeReview: "no",
    realtimeReviewConfig: {
      title: "실시간 리뷰",
      designType: "bubble",
      displayCount: 5,
      displayDelay: 3000,
      displayPeriod: "today",
      showUserId: true,
      showDate: true,
      showRating: true,
      reShowDelay: 24,
      pages: [],
      parentSelector: "",
      insertPosition: "append"
    },
    purchaseReview: "no",
    purchaseReviewConfig: {
      title: "지금 주문되고 있어요",
      designType: "ticker",
      // 노출 위치(designType별 의미 다름)
      //  - ticker     : 'top' | 'bottom'(기본)
      //  - card/bubble: 'top-left' | 'top-right' | 'bottom-left'(기본) | 'bottom-right'
      position: "bottom",
      enableMain: true,
      enableCategory: true,
      enableDetail: true,
      periodHours: 24,
      extendHours: 72,
      minDisplayCount: 5,
      displayCount: 10,
      rotationDelay: 4000,
      showReview: true,
      showReviewWriter: true,  // 리뷰 작성자 이름 노출 여부
      showBuyerName: true,     // 구매자 이름 자체 노출 여부 (false=buyer 영역 숨김)
      maskBuyer: true,         // PII 보호 — 항상 true 유지 (admin UI 미노출, 백엔드 마스킹)
      showTime: true,          // 시간 표시 여부 (기존 relativeTimeOnly 대체)
      reShowDelay: 24,         // 닫기 후 재노출 시간(시간), 0=항상 노출
      // 콘텐츠 다양화 옵션
      uniqueProduct: false,    // true=같은 상품 1회만, false=중복 허용
      matchMode: 'round_robin',// 'round_robin' | 'random' | 'rating_high' | 'rating_diverse'
      reviewPoolSize: 5,       // 상품별 리뷰 풀 크기
      minRating: 0,            // 최소 별점(0=제한 없음, 3/4/5)
      parentSelector: "",
      insertPosition: "append"
    }
  };

  @observable selectedPage = "";
  @observable selectedRealtimePage = "";

  // UX 리뉴얼: 아코디언 열림 상태 (한 번에 하나만 열리는 형태로 구현 가능)
  @observable openSection = 'reviewable'; // 진입 시 기본 탭(multi) 의 첫 위젯을 펼친 상태로 노출

  // 예제 보기 라이트박스 — 현재 노출 중인 캡처 (key) 또는 null
  @observable previewSample = null;
  // key → { src, caption } 매핑
  WIDGET_SAMPLES = {
    reviewInsight:    { src: widgetReviewInsight, caption: '리뷰 인사이트 위젯 — 예제' },
    aiRollingKeyword: { src: widgetAiKeyword,     caption: 'AI 리뷰 키워드 위젯 — 예제' },
    board:            { src: widgetBoard,         caption: '리뷰 게시판 위젯 — 예제' },
    reviewable:       { src: widgetWriterQ,       caption: '리뷰 작성 유도 위젯 — 예제' },
    realtime:         { src: widgetLiveReview,    caption: '실시간 리뷰 위젯 — 예제' },
    purchaseReview:   { src: widgetLiveOrder,     caption: '실시간 주문 위젯 — 예제' },
  };
  @action openPreviewSample = (key, e) => {
    if (e) e.stopPropagation(); // accordion toggle 방지
    if (this.WIDGET_SAMPLES[key]) this.previewSample = key;
  };
  @action closePreviewSample = () => { this.previewSample = null; };

  // UX 리뉴얼: 섹션별 dirty 상태 추적 (Sticky 저장 바 조건)
  @observable dirtyFlags = {
    reviewInsight: false,
    reviewRatingCount: false,
    aiRollingKeyword: false,
    reviewPage: false,
    reviewable: false,
    realtime: false,
    purchaseReview: false,
    myReview: false
  };

  // 섹션별 → 저장에 필요한 metaWidget 필드 목록 매핑
  SECTION_FIELDS = {
    reviewInsight:      ['reviewInsight', 'reviewInsightConfig'],
    reviewRatingCount:  ['reviewRatingCount', 'reviewRatingCountConfig'],
    aiRollingKeyword:   ['aiRollingKeyword', 'aiRollingKeywordBg'],
    reviewPage:         ['reviewPageType', 'reviewPagePath', 'reviewPageListCount', 'reviewPagePhotoCount', 'reviewPagePhotoSlider', 'reviewPagePhotoTitle', 'reviewPageConfig'],
    reviewable:         ['reviewableList', 'reviewableListConfig'],
    realtime:           ['realtimeReview', 'realtimeReviewConfig'],
    purchaseReview:     ['purchaseReview', 'purchaseReviewConfig'],
    myReview:           ['myReview', 'myReviewConfig']
  };
  SECTION_LABELS = {
    reviewInsight:      '리뷰 인사이트',
    reviewRatingCount:  '별점 및 리뷰수',
    aiRollingKeyword:   'AI 리뷰 키워드',
    reviewPage:         '리뷰 페이지',
    reviewable:         '리뷰 작성 유도',
    realtime:           '실시간 리뷰',
    purchaseReview:     '실시간 주문',
    myReview:           '나의리뷰 위젯'
  };

  // 삭제 확인 모달 타겟
  @observable pendingDeleteWidget = null;

  //modals
  @observable modals = {
    isNewWidget: false,
    isWidgetHeadSetiing: false,
    isReviewInsightSetting: false,
    isReviewRatingCountSetting: false,
    isReviewPageSetting: false,
    isRealtimeReviewSetting: false,
    isDeleteConfirm: false
  };


  constructor(props) {
    super(props);
    this.init()

    this.onChangeValue = this.onChangeValue.bind(this);

    // onChangeDataValue 의 빠른 연속 변경을 묶어 한 번에 저장하기 위한 debounce 인프라.
    // 같은 widget._id 의 여러 필드 변경이 _pendingUpdates 에 누적되고, 마지막 변경 후 400ms 뒤 1회 저장.
    this._pendingUpdates = {};
    this._debouncedSaves = {};
  }

  componentWillUnmount() {
    // 페이지 이탈 시 보류 중 저장을 즉시 실행 (변경 유실 방지)
    Object.keys(this._debouncedSaves || {}).forEach(id => {
      try { this._debouncedSaves[id].flush && this._debouncedSaves[id].flush(); } catch(e) {}
    });
  }


  componentDidUpdate(prevProps, prevState){

  }

  @action
  init = async (key) => {
    if(this.props.isLogin) {
      //basic
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.store = this.props.me.store ? this.props.me.store : {};
      this.isUse = false;
      if(this.teamUser.isPaidShop) {
        this.isUse = true;
      }
      this.permissions = this.props.me.permissions;

      // this.props.getDoc('getDesignConfig', {store_id: this.teamUser.selStore_id}, function(res) {
      //   if(res.errors && res.errors.length > 0) {
      //     alert(res.errors[0].message);
      //   }
      //   else {
      //     let results;
      //     if(res && res.data) {
      //       results = res.data;
      //       //console.log(results);
      //       if(results.store_id) {
      //         _this.basicWidget = results.commons ? results.commons : _this.basicWidget;
      //         _this.display = results.display ? results.display : _this.display;
      //       }
      //     }
      //   }
      // });
      this.getBasicSettings();
      this.loadMetaWidget();
      this.newWidget = {
        shopNo : this.teamUser.selShopNo ? this.teamUser.selShopNo :1,
        title: '',
        type: 'basic',
        selecting: 'newest',
        displayArea: 'main',
        col: 4,
        row: 1,
        isAutoPlay: 'true',
        reviewType: 'photo',
        style:{ style: defaultStyle },
        head:{ style: defaultHeadStyle }
      }
      this.listParams.store_id = this.teamUser.selStore_id;
      this.listParams.shopNo = this.teamUser.selShopNo ? this.teamUser.selShopNo :1;
      this.getWidgetList();
    }
  };

  getBasicSettings = async() => {
    let _this = this;
    this.props.getDoc('getBasicSettings', {store_id: this.teamUser.selStore_id}, function(res) {
      if(res.errors && res.errors.length > 0) {
        alert(res.errors[0].message);
      }
      else {
        if(res && res.data) {
          _this.basicWidget = res.data;
        }
      }
    });
  };

  getWidgetList = async() => {
    if(this.listParams.store_id) {
      this.list = await this.props.getWidgetList(this.listParams);
      this.isLoading = false;
    }
    else {
      //console.log('null store_id');
    }
  };

  loadMetaWidget = () => {
    let _this = this;
    this.props.getStoreTotalConfig({store_id: this.teamUser.selStore_id, shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1}, function(res) {
      if(res && res.metaWidget) {
        // mongoose Document 또는 observable proxy 충돌 방지: plain object 로 변환
        let mw;
        try { mw = JSON.parse(JSON.stringify(res.metaWidget)); } catch(e) { mw = res.metaWidget; }
        // top-level deep merge (default 보존 + 응답 우선)
        let merged = Object.assign({}, _this.metaWidget, mw);
        // nested object deep merge (response 의 누락 sub-key 도 default 로 보존)
        let nestedKeys = ['reviewInsightConfig', 'reviewRatingCountConfig', 'reviewPageConfig', 'productListConfig', 'reviewableListConfig', 'realtimeReviewConfig', 'purchaseReviewConfig'];
        nestedKeys.forEach(function(k) {
          if (mw[k] && typeof mw[k] === 'object') {
            merged[k] = Object.assign({}, _this.metaWidget[k] || {}, mw[k]);
          }
        });
        // 리뷰 인사이트 여백 기본값 보장: 비어있거나 누락된 경우 30px / 30px / 0px 강제 적용
        if (!merged.reviewInsightConfig) merged.reviewInsightConfig = {};
        if (!merged.reviewInsightConfig.marginTop)    merged.reviewInsightConfig.marginTop    = "30px";
        if (!merged.reviewInsightConfig.marginBottom) merged.reviewInsightConfig.marginBottom = "30px";
        if (!merged.reviewInsightConfig.lrPadding)    merged.reviewInsightConfig.lrPadding    = "0px";
        _this.metaWidget = merged;
      }
    });
  };

  onChangeMetaInputs = async (event, targetObj) => {
    let { name, value } = event.target;
    if(name && value){
      if(name === "reviewPageListCount" || name === "reviewPagePhotoCount") {
        targetObj[name] = parseInt(value);
      } else {
        targetObj[name] = value;
      }
    } else {
      targetObj[name] = value;
    }
    // UX 리뉴얼: dirty 플래그 자동 셋
    this.markDirtyByField(name);
  };

  // UX 리뉴얼: 필드 이름으로 섹션 dirty 플래그 지정
  markDirtyByField = (name) => {
    if (!name) return;
    // 상품상세 위젯들
    if (name === 'reviewInsight') this.dirtyFlags.reviewInsight = true;
    if (name === 'reviewRatingCount') this.dirtyFlags.reviewRatingCount = true;
    if (name === 'aiRollingKeyword' || name === 'aiRollingKeywordBg') this.dirtyFlags.aiRollingKeyword = true;
    // 리뷰 페이지
    if (name && name.startsWith('reviewPage')) this.dirtyFlags.reviewPage = true;
    // 리뷰 작성 유도
    if (name && name.startsWith('reviewable')) this.dirtyFlags.reviewable = true;
    // 실시간 리뷰
    if (name && (name.startsWith('realtime') || name === 'designType' || name === 'title' || name === 'displayCount' || name === 'displayPeriod' || name === 'displayDelay' || name === 'reShowDelay' || name === 'showUserId' || name === 'showDate' || name === 'showRating')) {
      this.dirtyFlags.realtime = true;
    }
    // 나의리뷰
    if (name && name.startsWith('myReview')) this.dirtyFlags.myReview = true;
  };

  @action markDirty = (sectionKey) => {
    if (this.dirtyFlags.hasOwnProperty(sectionKey)) this.dirtyFlags[sectionKey] = true;
  };

  @computed get dirtySections() {
    return Object.keys(this.dirtyFlags).filter(k => this.dirtyFlags[k]);
  }
  @computed get hasUnsaved() { return this.dirtySections.length > 0; }

  // 모든 dirty 섹션 한 번에 저장
  saveAllDirty = () => {
    const filters = [];
    this.dirtySections.forEach(sec => {
      const fields = this.SECTION_FIELDS[sec] || [];
      fields.forEach(f => filters.push(f));
    });
    if (filters.length === 0) return;
    this.updateMetaWidget(null, filters);
  };

  // 모든 dirty 되돌리기
  revertAllDirty = () => {
    this.loadMetaWidget();
    Object.keys(this.dirtyFlags).forEach(k => { this.dirtyFlags[k] = false; });
  };

  toggleAccordion = (key) => {
    this.openSection = this.openSection === key ? null : key;
  };

  updateMetaWidget = async (event, filter) => {
    let _this = this;
    // 백엔드의 store_id 비교(args.param.store_id == user.selStore_id)와 동일 식별자 사용
    let updateParams = {
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1
    };
    for(let i in filter) {
      let key = filter[i];
      updateParams[key] = this.metaWidget[key];
    }
    this.props.updateDoc('updateMetaWidget', updateParams, function(result, errors) {
      // updateDoc action 의 callback signature 는 (result, errors) — 두 번째 인자로 GraphQL errors 전달
      let hasError = (errors && errors.length > 0) || (result && result.errors && result.errors.length > 0)
                     || (result && result.message && !result.data);
      if (hasError) {
        let msg = (errors && errors[0] && errors[0].message)
                  || (result && result.errors && result.errors[0] && result.errors[0].message)
                  || (result && result.message)
                  || '저장에 실패했습니다.';
        toast.error(msg);
        return;
      }
      toast.success('저장 되었습니다.');
      // UX 리뉴얼: 저장 성공 시 필드 매핑으로 관련 섹션 dirty 해제
      if (filter && filter.length) {
        const filterSet = new Set(filter);
        Object.keys(_this.SECTION_FIELDS).forEach(sec => {
          const fields = _this.SECTION_FIELDS[sec] || [];
          if (fields.some(f => filterSet.has(f))) _this.dirtyFlags[sec] = false;
        });
      }
      // 백엔드의 최신 metaWidget 으로 화면 동기화 (deep object 내부 필드까지 반영)
      _this.loadMetaWidget();
    });
  };

  metaModalToggle = (type) => {
    this.modals[type] = !this.modals[type];
  };

  onChangeReviewInsightConfig = (event) => {
    const { name, value, type, checked } = event.target;
    if (!this.metaWidget.reviewInsightConfig) this.metaWidget.reviewInsightConfig = {};
    if (type === 'checkbox') { this.metaWidget.reviewInsightConfig[name] = checked; }
    else { this.metaWidget.reviewInsightConfig[name] = value; }
    // 박스 inline 편집 — sticky-save bar 통합용 dirty 마킹
    this.dirtyFlags.reviewInsight = true;
  };
  saveReviewInsightConfig = () => {
    this.updateMetaWidget(null, ["reviewInsightConfig"]);
    this.metaModalToggle('isReviewInsightSetting');
  };

  // 만족도 문장 리스트 — 인덱스 단위 편집/추가/삭제/프리셋
  ensureSatisfactionList = () => {
    if (!this.metaWidget.reviewInsightConfig) this.metaWidget.reviewInsightConfig = {};
    if (!Array.isArray(this.metaWidget.reviewInsightConfig.satisfactionSentences)) {
      this.metaWidget.reviewInsightConfig.satisfactionSentences = [];
    }
    return this.metaWidget.reviewInsightConfig.satisfactionSentences;
  };
  onChangeSatisfactionSentence = (idx, value) => {
    const list = this.ensureSatisfactionList();
    list[idx] = value;
    this.dirtyFlags.reviewInsight = true;
  };
  addSatisfactionSentence = () => {
    const list = this.ensureSatisfactionList();
    list.push('');
    this.dirtyFlags.reviewInsight = true;
  };
  removeSatisfactionSentence = (idx) => {
    const list = this.ensureSatisfactionList();
    list.splice(idx, 1);
    this.dirtyFlags.reviewInsight = true;
  };
  applySatisfactionPreset = (lang) => {
    const preset = SATISFACTION_PRESETS[lang];
    if (!preset) return;
    if (!this.metaWidget.reviewInsightConfig) this.metaWidget.reviewInsightConfig = {};
    this.metaWidget.reviewInsightConfig.satisfactionSentences = preset.slice();
    this.dirtyFlags.reviewInsight = true;
  };

  onChangeReviewRatingCountConfig = (event) => {
    const { name, value, type, checked } = event.target;
    if (!this.metaWidget.reviewRatingCountConfig) this.metaWidget.reviewRatingCountConfig = {};
    if (type === 'checkbox') { this.metaWidget.reviewRatingCountConfig[name] = checked; }
    else { this.metaWidget.reviewRatingCountConfig[name] = value; }
    // 박스 inline 편집 — sticky-save bar 통합용 dirty 마킹
    this.dirtyFlags.reviewRatingCount = true;
  };
  saveReviewRatingCountConfig = () => {
    this.updateMetaWidget(null, ["reviewRatingCountConfig"]);
    this.metaModalToggle('isReviewRatingCountSetting');
  };

  onChangeReviewPageConfig = (event) => {
    const { name, value, type, checked } = event.target;
    if (!this.metaWidget.reviewPageConfig) this.metaWidget.reviewPageConfig = {};
    if (type === 'checkbox') { this.metaWidget.reviewPageConfig[name] = checked; }
    else { this.metaWidget.reviewPageConfig[name] = value; }
    // 박스 inline 편집 — sticky-save bar 통합용 dirty 마킹
    this.dirtyFlags.reviewPage = true;
  };
  saveReviewPageConfig = () => {
    this.updateMetaWidget(null, ["reviewPageConfig"]);
    this.metaModalToggle('isReviewPageSetting');
  };

  // 나의리뷰(마이페이지) 위젯 — 리뷰 페이지와 동일 패턴
  onChangeMyReviewConfig = (event) => {
    const { name, value, type, checked } = event.target;
    if (!this.metaWidget.myReviewConfig) this.metaWidget.myReviewConfig = {};
    if (type === 'checkbox') { this.metaWidget.myReviewConfig[name] = checked; }
    else if (name === 'listCount') { this.metaWidget.myReviewConfig[name] = parseInt(value, 10) || 5; }
    else { this.metaWidget.myReviewConfig[name] = value; }
    this.dirtyFlags.myReview = true;
  };
  setMyReviewOnOff = (v) => {
    this.metaWidget.myReview = v;
    this.dirtyFlags.myReview = true;
  };

  addReviewablePage = () => {
    if (this.selectedPage && !this.metaWidget.reviewableListConfig.pages.includes(this.selectedPage)) {
      this.metaWidget.reviewableListConfig.pages.push(this.selectedPage);
      this.selectedPage = "";
      this.dirtyFlags.reviewable = true;
    }
  };

  removeReviewablePage = (page) => {
    this.metaWidget.reviewableListConfig.pages = this.metaWidget.reviewableListConfig.pages.filter(p => p !== page);
    this.dirtyFlags.reviewable = true;
  };

  // UX 리뉴얼: reviewableList 토글/페이지/딜레이 모두 이 onChange 로 거치도록 사용
  toggleReviewableList = () => {
    this.metaWidget.reviewableList = this.metaWidget.reviewableList === 'yes' ? 'no' : 'yes';
    this.dirtyFlags.reviewable = true;
  };

  toggleRealtimeReview = () => {
    this.metaWidget.realtimeReview = this.metaWidget.realtimeReview === 'yes' ? 'no' : 'yes';
    this.dirtyFlags.realtime = true;
  };

  toggleRealtimeShowFlag = (flag) => {
    this.metaWidget.realtimeReviewConfig[flag] = !(this.metaWidget.realtimeReviewConfig[flag] !== false);
    this.dirtyFlags.realtime = true;
  };

  onChangeRealtimeReviewConfig = (event) => {
    const { name, value, type, checked } = event.target;
    if (!this.metaWidget.realtimeReviewConfig) this.metaWidget.realtimeReviewConfig = {};
    if (type === 'checkbox') { this.metaWidget.realtimeReviewConfig[name] = checked; }
    else if (name === 'displayCount' || name === 'displayDelay' || name === 'reShowDelay') { this.metaWidget.realtimeReviewConfig[name] = parseInt(value); }
    else { this.metaWidget.realtimeReviewConfig[name] = value; }
    this.dirtyFlags.realtime = true;
  };

  togglePurchaseReview = () => {
    this.metaWidget.purchaseReview = this.metaWidget.purchaseReview === 'yes' ? 'no' : 'yes';
    this.dirtyFlags.purchaseReview = true;
  };

  togglePurchaseScope = (scopeKey) => {
    if (!this.metaWidget.purchaseReviewConfig) this.metaWidget.purchaseReviewConfig = {};
    const cfg = this.metaWidget.purchaseReviewConfig;
    const key = scopeKey === 'main' ? 'enableMain' : scopeKey === 'category' ? 'enableCategory' : 'enableDetail';
    cfg[key] = !(cfg[key] !== false);
    this.dirtyFlags.purchaseReview = true;
  };

  togglePurchaseBoolean = (flag) => {
    if (!this.metaWidget.purchaseReviewConfig) this.metaWidget.purchaseReviewConfig = {};
    this.metaWidget.purchaseReviewConfig[flag] = !(this.metaWidget.purchaseReviewConfig[flag] !== false);
    this.dirtyFlags.purchaseReview = true;
  };

  onChangePurchaseReviewConfig = (event) => {
    const { name, value, type, checked } = event.target;
    if (!this.metaWidget.purchaseReviewConfig) this.metaWidget.purchaseReviewConfig = {};
    if (type === 'checkbox') {
      this.metaWidget.purchaseReviewConfig[name] = checked;
    } else if (name === 'periodHours' || name === 'extendHours' || name === 'minDisplayCount' || name === 'displayCount' || name === 'rotationDelay' || name === 'reShowDelay' || name === 'reviewPoolSize' || name === 'minRating') {
      this.metaWidget.purchaseReviewConfig[name] = parseInt(value) || 0;
    } else {
      this.metaWidget.purchaseReviewConfig[name] = value;
    }
    this.dirtyFlags.purchaseReview = true;
  };

  // 디자인 변경 시 position 도 해당 디자인의 유효한 값으로 자동 동기화
  // (틱커는 'top'/'bottom', 카드·말풍선은 'top-left'/'top-right'/'bottom-left'/'bottom-right')
  changePurchaseDesignType = (designKey) => {
    if (!this.metaWidget.purchaseReviewConfig) this.metaWidget.purchaseReviewConfig = {};
    const cfg = this.metaWidget.purchaseReviewConfig;
    cfg.designType = designKey;
    const tickerSet = ['top', 'bottom'];
    const floatSet = ['top-left', 'top-right', 'bottom-left', 'bottom-right'];
    const isTicker = designKey === 'ticker';
    const valid = isTicker ? tickerSet : floatSet;
    if (!valid.includes(cfg.position)) {
      cfg.position = isTicker ? 'bottom' : 'bottom-left';
    }
    this.dirtyFlags.purchaseReview = true;
  };

  onChangeReviewableConfig = (event) => {
    const { name, value } = event.target;
    this.metaWidget.reviewableListConfig[name] = value;
    this.dirtyFlags.reviewable = true;
  };

  addRealtimePage = () => {
    if (this.selectedRealtimePage && !this.metaWidget.realtimeReviewConfig.pages.includes(this.selectedRealtimePage)) {
      this.metaWidget.realtimeReviewConfig.pages.push(this.selectedRealtimePage);
      this.selectedRealtimePage = "";
      this.dirtyFlags.realtime = true;
    }
  };

  removeRealtimePage = (page) => {
    this.metaWidget.realtimeReviewConfig.pages = this.metaWidget.realtimeReviewConfig.pages.filter(p => p !== page);
    this.dirtyFlags.realtime = true;
  };
  saveRealtimeReviewConfig = () => {
    this.updateMetaWidget(null, ["realtimeReviewConfig"]);
    this.metaModalToggle('isRealtimeReviewSetting');
  };


  onChangeValue = async (event, targetObj) => {
    const { name, value } = event.target;
    if(targetObj) {
      if(name === "isTitleDis") {
        targetObj[name] = value === "true";
      }
      else if(name === "rating" || name === "count") {
        targetObj[name] = value === "false";
      }
      else {
        targetObj[name] = value;
      }
      console.log(targetObj)
    }
  };

  updateWidget = async () => {
    let _this = this;

    if(!_this.newWidget.title) {
      alert('제목을 입력해 주세요.');
      return false;
    }

    if(_this.newWidget.row) {
      _this.newWidget.row = parseInt(_this.newWidget.row);
    }
    if(_this.newWidget.col) {
      _this.newWidget.col = parseInt(_this.newWidget.col);
    }
    // if(_this.newWidget.type === 'slider') {
    //   _this.newWidget.dataPer = 2;
    // }

    let tempNewWidget = {..._this.newWidget}
    tempNewWidget.store_id = _this.teamUser.selStore_id;
    tempNewWidget.title = _this.newWidget.title;

    // for(let key in _this.newWidgetProps) {
    //   tempNewWidget[key] = _this.newWidget[key];
    // }



    if(!tempNewWidget.head) {
      tempNewWidget.head = {
        style: defaultHeadStyle
      }
    }
    if(!tempNewWidget.head.title) {
      tempNewWidget.head.title = tempNewWidget.title;
    }


    console.log(tempNewWidget)
    this.props.updateWidget(tempNewWidget, function(res) {
      if(res.errors && res.errors.length > 0) {
        alert(res.errors[0].message);
      }
      else {
        _this.modals.isNewWidget = false;
        _this.getWidgetList();
        //window.location.reload();
      }

    });
  };


  onChangeDataValue = (item, event) => {
    const { name, value } = event.target;
    // 정수 강제 변환이 필요한 필드
    let coerced = value;
    if (name === 'row' || name === 'col' || name === 'dataPer') {
      coerced = parseInt(value);
    }
    item[name] = coerced; // UI 즉시 반응

    // 같은 widget 의 여러 필드 변경을 누적
    if (!this._pendingUpdates[item._id]) {
      this._pendingUpdates[item._id] = {
        id: item._id,
        store_id: this.teamUser.selStore_id,
        _title: item.title
      };
    }
    this._pendingUpdates[item._id][name] = coerced;
    this._pendingUpdates[item._id]._title = item.title;

    // widget 별 debounce 핸들러 캐시 (마지막 변경 후 400ms 후 1회 저장)
    if (!this._debouncedSaves[item._id]) {
      this._debouncedSaves[item._id] = _.debounce((widgetId) => this._flushDataSave(widgetId), 400);
    }
    this._debouncedSaves[item._id](item._id);
  };

  _flushDataSave = (widgetId) => {
    const pending = this._pendingUpdates[widgetId];
    if (!pending) return;
    delete this._pendingUpdates[widgetId];
    const title = pending._title || '';
    delete pending._title;

    let _this = this;
    this.props.updateWidget(pending, function(res) {
      if (res.errors && res.errors.length > 0) {
        alert(res.errors[0].message);
      }
      else {
        toast('"' + title + '" 위젯 수정이 완료되었습니다.');
        _this.getWidgetList();
      }
    });
  };

  onChangeStyleValue = async (item) => {
    let _this = this;

    item.head.style.marginTop = 0;
    let updateWidget = {
      id: item._id,
      title: item.title,
      store_id: this.teamUser.selStore_id,
      isTitleDis: item.isTitleDis === true,
      style: item.style,
      head: item.head,
      display: item.display,
    };

    // 슬라이더 타입인 경우 슬라이드 설정 추가
    if (item.slideDelay) {
      updateWidget.slideDelay = parseInt(item.slideDelay);
    }
    if (item.slidesToScroll) {
      updateWidget.slidesToScroll = parseInt(item.slidesToScroll);
    }
    if (item.mobileSlidesPerView) {
      updateWidget.mobileSlidesPerView = parseInt(item.mobileSlidesPerView);
    }

    this.props.updateWidget(updateWidget, function(res) {
      if(res.errors && res.errors.length > 0) {
        alert(res.errors[0].message);
      }
      else {
        toast('"' + item.title + '" 위젯 수정이 완료되었습니다.');
        _this.modals.isWidgetHeadSetiing = false;
        _this.getWidgetList();
      }

    });
  };

  // updateBasicWidget = async (target) => {
  //
  //   let data = this.basicWidget;
  //   data.store_id = this.teamUser.selStore_id;
  //   this.props.updateDoc('updateBasicSettings', data, function(res) {
  //     if(res.errors && res.errors.length > 0) {
  //       toast(res.errors[0].message);
  //     }
  //     else {
  //       toast('저장 되었습니다.');
  //     }
  //     //todo 페이지 새로 고침
  //   });
  // };



  onCopyWidgetCode = async (item) => {
    let htmlCode = '<div id="orvwig-' + item._id +'" widget_id="' + item._id +'" class="onreview-code-widget" style="display: none;"></div>';
    window.navigator.clipboard.writeText(htmlCode).then(() => {
      // 복사가 완료되면 이 부분이 호출된다.
      alert('코드가 복사 되었습니다. ( pc, 모바일 모두 사용가능합니다. )');
    });
  };

  onShowReviews = async (item) => {
    window.open('/reviewList?widget_id=' + item._id);
  };

  // UX 리뉴얼: 삭제 버튼 클릭 시 확인 모달 오픈 (B-3)
  onRemoveWidget = (item) => {
    this.pendingDeleteWidget = item;
    this.modals.isDeleteConfirm = true;
  };

  confirmRemoveWidget = async () => {
    let _this = this;
    if (!this.pendingDeleteWidget) return;

    let delWidget = {
      id: this.pendingDeleteWidget._id,
      store_id: this.teamUser.selStore_id
    };

    this.props.removeWidget(delWidget, function(res) {
      if(res.errors && res.errors.length > 0) {
        toast.error(res.errors[0].message);
      }
      else {
        toast.success('위젯이 삭제되었습니다.');
        _this.getWidgetList();
      }
      _this.modals.isDeleteConfirm = false;
      _this.pendingDeleteWidget = null;
    });
  };

  cancelRemoveWidget = () => {
    this.modals.isDeleteConfirm = false;
    this.pendingDeleteWidget = null;
  };

  editHeadModalOpen = async (item) => {
    if(!item.style) {
      item.style = defaultStyle;
    }
    if(!item.head) {
      item.head = {
        title : item.title,
        style : defaultHeadStyle
      }
    }
    if(!item.display) {
      item.display = {
        rating: true,
        count: true
      };
    }
    this.curWidget = item;
    this.modals.isWidgetHeadSetiing = true;
  };

  modalToggle = function(target, data) {
    if(this.isShowMColor_1) {
      this.isShowMColor_1 = false;
    }
    // this.modals[target] = !this.modals[target];
    // if(!target) {
    //   for( var i in this.modals) {
    //     this.modals[i] = false;
    //   }
    // }
    if(data) {
      this.modals.data = data;
    }
  };

  onChangeColor =  async (name, color, targetObj) => {
    targetObj[name] = color.hex;
    // this.showColorModalFn();
  };

  getFilteredDocs = () => {
    if (!this.list || !this.list.docs) return [];
    const tabConfig = pageTabProps.find(t => t.key === this.activeTab);
    if (!tabConfig) return this.list.docs;
    return this.list.docs.filter(item => tabConfig.areas.includes(item.displayArea));
  };

  showColorModalFn =  async (targetModal) => {
    if(targetModal) {
      this[targetModal] = true;
    }
    else {
      this.isShowMColor_1 = false;
    }
  };

  render() {
    let _this = this;

    // (구) Pagination 함수 — 호출처 없음. 추후 페이지네이션이 필요할 때 다시 도입.

    return (
      <div className="main-content">
        <PageTitle />

        {(this.isLogin && this.teamUser && !this.teamUser.isPaidShop) && (
          <div className="es-paywall-banner">
            <FeatherIcon icon="lock" size="14"/>
            <span><strong>위젯 설정 화면은 무료로 확인</strong>할 수 있습니다. 위젯 설정 변경 / 저장 / 적용은 <strong>유료 플랜 전용</strong>입니다.</span>
            <button type="button" className="es-paywall-banner__cta"
                    onClick={() => { window.location.href = '/inAppOrder'; }}>
              <FeatherIcon icon="credit-card" size="13"/>
              결제페이지로 이동하기
              <FeatherIcon icon="arrow-right" size="13"/>
            </button>
          </div>
        )}

        <div className="widget-box">

          <div className="widget-page-tabs">
            <div className="page-tab-header">
              <h3>페이지별 위젯 설정</h3>
              <p>위젯을 적용할 페이지를 선택하세요</p>
            </div>
            <div className="page-tab-list">
              {pageTabProps.map((tab) => (
                <div key={tab.key}
                    className={`page-tab-item ${this.activeTab === tab.key ? 'active' : ''}`}
                    onClick={() => {
                      this.activeTab = tab.key;
                      // 탭 전환 시 해당 탭의 첫 위젯을 자동 펼침
                      this.openSection = tab.key === 'multi' ? 'reviewable'
                                       : tab.key === 'detail' ? 'reviewInsight'
                                       : tab.key === 'board' ? 'board'
                                       : tab.key === 'mypage' ? 'myReview'
                                       : null;
                    }}>
                  <i className="material-icons page-tab-icon">
                    {tab.key === 'main' && 'home'}
                    {tab.key === 'detail' && 'shopping_bag'}
                    {tab.key === 'board' && 'rate_review'}
                    {tab.key === 'mypage' && 'person'}
                    {tab.key === 'multi' && 'web'}
                  </i>
                  <span className="page-tab-label">{tab.label}</span>
                </div>
              ))}
            </div>
          </div>


          {/* 상품 상세 탭: 3개 위젯 박스(리뷰 인사이트 / 별점 및 리뷰수 / AI 리뷰 키워드) */}
          {(this.activeTab === 'detail') && (
          <React.Fragment>

            {/* 위젯 1: 리뷰 인사이트 */}
            <div className={`wbp-accordion ${this.openSection === 'reviewInsight' ? 'is-open' : ''}`} style={{marginTop: 16}}>
              <div className="wbp-accordion__head" onClick={() => this.toggleAccordion('reviewInsight')}>
                <div className="wbp-accordion__title">
                  <FeatherIcon icon="activity" size="16" />
                  <span>리뷰 인사이트</span>
                  <span className={`wbp-status-chip ${this.metaWidget.reviewInsight === 'type_1' ? 'is-on' : 'is-off'}`}>
                    {this.metaWidget.reviewInsight === 'type_1' ? 'ON' : 'OFF'}
                  </span>
                  <button type="button" className="wbp-accordion__sample-btn"
                          onClick={(e) => this.openPreviewSample('reviewInsight', e)}
                          title="예제 이미지 보기">
                    <FeatherIcon icon="image" size="13" /> 예제 보기
                  </button>
                </div>
                <div className="wbp-accordion__toggle">
                  <FeatherIcon icon={this.openSection === 'reviewInsight' ? 'chevron-up' : 'chevron-down'} size="18" />
                </div>
              </div>
              <div className="wbp-accordion__body" style={{display: this.openSection === 'reviewInsight' ? 'block' : 'none'}}>
              <div className="section-box" style={{marginTop: 0, border: 'none', boxShadow: 'none', padding: '4px 4px 12px'}}>
                <table className="s-table">
                  <colgroup><col width="200px"/><col /></colgroup>
                  <tbody>
                  <tr>
                    <th>리뷰 인사이트</th>
                    <td className="text-left">
                      <FormCheckbox toggle small
                        checked={this.metaWidget.reviewInsight === "type_1"}
                        onChange={() => { this.metaWidget.reviewInsight = this.metaWidget.reviewInsight === 'type_1' ? 'no' : 'type_1'; this.markDirty('reviewInsight'); }}>
                        {this.metaWidget.reviewInsight === 'type_1' ? '사용함' : '사용안함'}
                      </FormCheckbox>
                    </td>
                  </tr>
                  <tr>
                    <th>부모 클래스/ID</th>
                    <td className="text-left">
                      <FormInput name="parentSelector"
                                 value={this.metaWidget.reviewInsightConfig.parentSelector || ''}
                                 onChange={this.onChangeReviewInsightConfig}
                                 placeholder=".class-name 또는 #element-id"
                                 style={{maxWidth: 420}} />
                      <p style={{marginTop: 5, marginBottom: 0, fontSize: 12, color: '#6B7280'}}>예: <code>.review-container</code>, <code>#review-wrap</code></p>
                    </td>
                  </tr>
                  <tr>
                    <th>위젯 삽입 위치</th>
                    <td className="text-left">
                      <FormSelect name="insertPosition"
                                  value={this.metaWidget.reviewInsightConfig.insertPosition || 'append'}
                                  onChange={this.onChangeReviewInsightConfig}
                                  style={{maxWidth: 320}}>
                        <option value="append">지정 요소 내부의 맨 끝에 추가</option>
                        <option value="prepend">지정 요소 내부의 맨 앞에 추가</option>
                        <option value="after">지정 요소 바로 뒤에 추가 (형제 요소)</option>
                        <option value="before">지정 요소 바로 앞에 추가 (형제 요소)</option>
                        <option value="html">지정 요소의 내용을 대체</option>
                      </FormSelect>
                    </td>
                  </tr>
                  <tr>
                    <th>위젯 최대너비</th>
                    <td className="text-left">
                      <FormInput name="maxWidth"
                                 value={this.metaWidget.reviewInsightConfig.maxWidth || ''}
                                 onChange={this.onChangeReviewInsightConfig}
                                 placeholder="예: 100%, 1200px, auto"
                                 style={{maxWidth: 220}} />
                    </td>
                  </tr>
                  <tr>
                    <th>여백 (상단/하단/좌우)</th>
                    <td className="text-left">
                      <div style={{display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap'}}>
                        <FormInput name="marginTop"
                                   value={this.metaWidget.reviewInsightConfig.marginTop || ''}
                                   onChange={this.onChangeReviewInsightConfig}
                                   placeholder="상단"
                                   style={{width: 120}} />
                        <FormInput name="marginBottom"
                                   value={this.metaWidget.reviewInsightConfig.marginBottom || ''}
                                   onChange={this.onChangeReviewInsightConfig}
                                   placeholder="하단"
                                   style={{width: 120}} />
                        <FormInput name="lrPadding"
                                   value={this.metaWidget.reviewInsightConfig.lrPadding || ''}
                                   onChange={this.onChangeReviewInsightConfig}
                                   placeholder="좌우"
                                   style={{width: 120}} />
                        <span style={{fontSize: 12, color: '#9CA3AF'}}>예: 20px, 1rem</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>표시 옵션</th>
                    <td className="text-left">
                      <div style={{display: 'flex', gap: 18, alignItems: 'center', flexWrap: 'wrap'}}>
                        <FormCheckbox toggle small
                                      name="showRating"
                                      checked={!!this.metaWidget.reviewInsightConfig.showRating}
                                      onChange={this.onChangeReviewInsightConfig}>
                          별점 표시 {this.metaWidget.reviewInsightConfig.showRating ? '사용' : '미사용'}
                        </FormCheckbox>
                        <FormCheckbox toggle small
                                      name="showCount"
                                      checked={!!this.metaWidget.reviewInsightConfig.showCount}
                                      onChange={this.onChangeReviewInsightConfig}>
                          카운트 표시 {this.metaWidget.reviewInsightConfig.showCount ? '사용' : '미사용'}
                        </FormCheckbox>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>만족도 문장 리스트</th>
                    <td className="text-left">
                      <div style={{display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap', marginBottom: 10}}>
                        <span style={{fontSize: 12, color: '#6B7280', marginRight: 4}}>프리셋:</span>
                        <Button size="sm" theme="light" onClick={() => this.applySatisfactionPreset('ko')}>한국어</Button>
                        <Button size="sm" theme="light" onClick={() => this.applySatisfactionPreset('en')}>English</Button>
                        <Button size="sm" theme="light" onClick={() => this.applySatisfactionPreset('jp')}>日本語</Button>
                        <span style={{fontSize: 12, color: '#9CA3AF', marginLeft: 6}}>
                          프리셋 클릭 시 현재 리스트가 교체됩니다.
                        </span>
                      </div>
                      <div style={{display: 'flex', flexDirection: 'column', gap: 6, maxWidth: 720}}>
                        {(this.metaWidget.reviewInsightConfig.satisfactionSentences || []).map((sentence, idx) => (
                          <div key={idx} style={{display: 'flex', gap: 6, alignItems: 'center'}}>
                            <span style={{minWidth: 22, textAlign: 'right', fontSize: 12, color: '#9CA3AF'}}>{idx + 1}.</span>
                            <FormInput
                              value={sentence || ''}
                              onChange={(e) => this.onChangeSatisfactionSentence(idx, e.target.value)}
                              placeholder="예) 구매 고객 만족도 {p}%"
                              style={{flex: 1, fontSize: 13}} />
                            <Button size="sm" theme="light" onClick={() => this.removeSatisfactionSentence(idx)}
                                    title="삭제">
                              <FeatherIcon icon="trash-2" size="14" />
                            </Button>
                          </div>
                        ))}
                      </div>
                      <div style={{marginTop: 8, display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap'}}>
                        <Button size="sm" theme="primary" onClick={this.addSatisfactionSentence}>
                          <FeatherIcon icon="plus" size="12" style={{verticalAlign: 'middle', marginRight: 3}} />
                          문장 추가
                        </Button>
                        <p style={{margin: 0, fontSize: 12, color: '#6B7280'}}>
                          <code>{'{p}'}</code> 는 실제 만족도 퍼센트로 치환되고, 여러 문장 중 랜덤으로 1개가 노출됩니다.
                        </p>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
                {/* 저장은 하단 sticky-save 통합 바에서 일괄 처리 */}
              </div>
              </div>
            </div>

            {/* 위젯 2(별점 및 리뷰수) — reviewWriteConfig.js "상세페이지 리뷰 정보 표시 설정" 으로 이전됨 */}

            {/* 위젯 3: AI 리뷰 키워드 */}
            <div className={`wbp-accordion ${this.openSection === 'aiRollingKeyword' ? 'is-open' : ''}`} style={{marginTop: 16}}>
              <div className="wbp-accordion__head" onClick={() => this.toggleAccordion('aiRollingKeyword')}>
                <div className="wbp-accordion__title">
                  <FeatherIcon icon="cpu" size="16" />
                  <span>AI 리뷰 키워드</span>
                  <span
                    className="wbp-help"
                    title="AI가 리뷰에서 자주 언급된 키워드를 자동 추출해 메인/카테고리 페이지 하단에 띠 형태로 노출합니다. 리뷰 20건 이상 상품에서 자동 생성되며 1개월마다 갱신됩니다."
                    onClick={(e) => e.stopPropagation()}
                  >
                    <FeatherIcon icon="help-circle" size="13" />
                  </span>
                  <span className="mw-beta-badge">BETA</span>
                  <span className={`wbp-status-chip ${this.metaWidget.aiRollingKeyword === 'type_1' ? 'is-on' : 'is-off'}`}>
                    {this.metaWidget.aiRollingKeyword === 'type_1' ? 'ON' : 'OFF'}
                  </span>
                  <button type="button" className="wbp-accordion__sample-btn"
                          onClick={(e) => this.openPreviewSample('aiRollingKeyword', e)}
                          title="예제 이미지 보기">
                    <FeatherIcon icon="image" size="13" /> 예제 보기
                  </button>
                </div>
                <div className="wbp-accordion__toggle">
                  <FeatherIcon icon={this.openSection === 'aiRollingKeyword' ? 'chevron-up' : 'chevron-down'} size="18" />
                </div>
              </div>
              <div className="wbp-accordion__body" style={{display: this.openSection === 'aiRollingKeyword' ? 'block' : 'none'}}>
              <div className="section-box" style={{marginTop: 0, border: 'none', boxShadow: 'none', padding: '4px 4px 12px'}}>
                <table className="s-table">
                  <colgroup><col width="200px"/><col width="20%"/><col /><col width="20%"/></colgroup>
                  <tbody>
                  <tr>
                    <th>AI 리뷰 키워드
                      <span className="wbp-help" title="리뷰 20개 이상 상품만 노출됩니다."><FeatherIcon icon="help-circle" size="13" /></span>
                    </th>
                    <td colSpan={3} className="text-left">
                      <FormCheckbox toggle small
                        checked={this.metaWidget.aiRollingKeyword === "type_1"}
                        onChange={() => { this.metaWidget.aiRollingKeyword = this.metaWidget.aiRollingKeyword === 'type_1' ? 'no' : 'type_1'; this.markDirty('aiRollingKeyword'); }}>
                        {this.metaWidget.aiRollingKeyword === 'type_1' ? '사용함' : '사용안함'}
                      </FormCheckbox>
                      <div className={`mw-theme-grid ${this.metaWidget.aiRollingKeyword !== 'type_1' ? 'is-disabled' : ''}`} style={{marginTop: '14px'}}>
                        {[
                          { name: '기본', value: 'theme-0', colors: ['#667eea', '#764ba2'] },
                          { name: '선셋 오렌지', value: 'theme-1', colors: ['#ff9966', '#ff5e62'] },
                          { name: '오로라 그린', value: 'theme-2', colors: ['#56ab2f', '#a8e063'] },
                          { name: '네온 블루', value: 'theme-3', colors: ['#00c6ff', '#0072ff'] },
                          { name: '코랄 핑크', value: 'theme-4', colors: ['#ff758c', '#ff7eb3'] },
                          { name: '모노 블랙', value: 'theme-5', colors: ['#232526', '#414345'] },
                          { name: '레트로 퍼플', value: 'theme-6', colors: ['#8e2de2', '#4a00e0'] },
                          { name: '민트 아이스', value: 'theme-7', colors: ['#43e97b', '#38f9d7'] },
                          { name: '로열 골드', value: 'theme-8', colors: ['#f7971e', '#ffd200'] },
                          { name: '미드나잇 블루', value: 'theme-9', colors: ['#2c3e50', '#3498db'] },
                          { name: '플라밍고 레드', value: 'theme-10', colors: ['#e53935', '#e35d5b'] },
                        ].map((theme, idx) => {
                          const active = this.metaWidget.aiRollingKeywordBg === theme.value;
                          return (
                            <div key={idx} className={`mw-theme-card ${active ? 'is-active' : ''}`}
                                 onClick={() => {
                                   if (this.metaWidget.aiRollingKeyword !== 'type_1') return;
                                   this.onChangeMetaInputs({target:{name:'aiRollingKeywordBg', value: theme.value}}, this.metaWidget);
                                 }}>
                              <div className="mw-theme-card__preview" style={{background: `linear-gradient(135deg, ${theme.colors[0]}, ${theme.colors[1]})`}}>
                                {active && <FeatherIcon icon="check" size="16" />}
                              </div>
                              <div className="mw-theme-card__name">{theme.name}</div>
                            </div>
                          );
                        })}
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
                {/* 저장은 하단 sticky-save 통합 바에서 일괄 처리 */}
              </div>
              </div>
            </div>

          </React.Fragment>
          )}

          {/* 리뷰 게시판 탭: 리뷰 페이지 설정 === 아코디언 === */}
          {(this.activeTab === 'board') && (
          <div className={`wbp-accordion ${this.openSection === 'board' ? 'is-open' : ''}`} style={{marginTop: 16}}>
            <div className="wbp-accordion__head" onClick={() => this.toggleAccordion('board')}>
              <div className="wbp-accordion__title">
                <FeatherIcon icon="message-square" size="16" />
                <span>리뷰 페이지 설정</span>
                <span className={`wbp-status-chip ${this.metaWidget.reviewPageType && this.metaWidget.reviewPageType !== 'no' ? 'is-on' : 'is-off'}`}>
                  {this.metaWidget.reviewPageType && this.metaWidget.reviewPageType !== 'no' ? 'ON' : 'OFF'}
                </span>
                <button type="button" className="wbp-accordion__sample-btn"
                        onClick={(e) => this.openPreviewSample('board', e)}
                        title="예제 이미지 보기">
                  <FeatherIcon icon="image" size="13" /> 예제 보기
                </button>
              </div>
              <div className="wbp-accordion__toggle">
                <FeatherIcon icon={this.openSection === 'board' ? 'chevron-up' : 'chevron-down'} size="18" />
              </div>
            </div>
            <div className="wbp-accordion__body" style={{display: this.openSection === 'board' ? 'block' : 'none'}}>
            <div className="section-box" style={{marginTop: 0, border: 'none', boxShadow: 'none', padding: '4px 4px 12px'}}>
              <table className="s-table">
                <colgroup>
                  <col width="200px"/><col width="40%"/><col />
                </colgroup>
                <tbody>
                <tr>
                  <th>리뷰 페이지 주소</th>
                  <td colSpan={2} className="text-left">
                    <FormInput name="reviewPagePath" placeholder="/board/구매후기/4/" value={this.metaWidget.reviewPagePath}
                      onChange={(event) => this.onChangeMetaInputs(event, this.metaWidget)} className="table-input-text search-input"/>
                    <p>여러 페이지 주소를 등록할 수 있으며, 각 주소는 쉼표(,)로 구분해 주세요.<br />
                      예: /board/product/list.html?board_no=4, /board/상품-사용후기/4/</p>
                  </td>
                </tr>
                <tr>
                  <th>포토리뷰/리스트</th>
                  <td colSpan={2} className="text-left">
                    <div className="mw-page-check-list">
                      {[
                        {key: 'both', label: '포토리뷰 + 리스트', icon: 'layout'},
                        {key: 'list', label: '리스트', icon: 'list'},
                        {key: 'photo', label: '포토리뷰', icon: 'image'},
                        {key: 'no', label: '사용안함', icon: 'x-circle'}
                      ].map(o => {
                        const cur = this.metaWidget.reviewPageType || 'both';
                        const active = cur === o.key;
                        return (
                          <label key={o.key} className={`mw-page-check ${active ? 'is-checked' : ''}`}
                                 onClick={() => this.onChangeMetaInputs({target:{name:'reviewPageType', value: o.key}}, this.metaWidget)}>
                            <FeatherIcon icon={o.icon} size="16" />
                            <span>{o.label}</span>
                          </label>
                        );
                      })}
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>리스트 페이지당 리뷰수</th>
                  <td className="text-left">
                    <FormSelect value={this.metaWidget.reviewPageListCount} name="reviewPageListCount"
                      onChange={event => this.onChangeMetaInputs(event, this.metaWidget)}>
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="20">20</option>
                    </FormSelect>
                  </td>
                  <td className="text-left"></td>
                </tr>
                <tr>
                  <th>포토리뷰 리뷰수</th>
                  <td className="text-left">
                    <FormSelect value={this.metaWidget.reviewPagePhotoCount} name="reviewPagePhotoCount"
                      onChange={event => this.onChangeMetaInputs(event, this.metaWidget)}>
                      <option value="4">4</option><option value="8">8</option><option value="12">12</option>
                      <option value="16">16</option><option value="20">20</option><option value="24">24</option><option value="28">28</option>
                    </FormSelect>
                  </td>
                  <td className="text-left"></td>
                </tr>
                <tr>
                  <th>포토리뷰 타이틀</th>
                  <td colSpan={2} className="text-left">
                    <FormInput name="reviewPagePhotoTitle" placeholder="" value={this.metaWidget.reviewPagePhotoTitle}
                      onChange={(event) => this.onChangeMetaInputs(event, this.metaWidget)} className="table-input-text search-input"/>
                  </td>
                </tr>
                <tr>
                  <th>부모 클래스/ID</th>
                  <td colSpan={2} className="text-left">
                    <FormInput name="parentSelector"
                               value={(this.metaWidget.reviewPageConfig && this.metaWidget.reviewPageConfig.parentSelector) || ''}
                               onChange={this.onChangeReviewPageConfig}
                               placeholder=".class-name 또는 #element-id"
                               style={{maxWidth: 420}} />
                    <p style={{marginTop: 5, marginBottom: 0, fontSize: 12, color: '#6B7280'}}>예: <code>.review-container</code>, <code>#review-wrap</code></p>
                  </td>
                </tr>
                <tr>
                  <th>위젯 삽입 위치</th>
                  <td colSpan={2} className="text-left">
                    <FormSelect name="insertPosition"
                                value={(this.metaWidget.reviewPageConfig && this.metaWidget.reviewPageConfig.insertPosition) || 'append'}
                                onChange={this.onChangeReviewPageConfig}
                                style={{maxWidth: 320}}>
                      <option value="append">지정 요소 내부의 맨 끝에 추가</option>
                      <option value="prepend">지정 요소 내부의 맨 앞에 추가</option>
                      <option value="after">지정 요소 바로 뒤에 추가 (형제 요소)</option>
                      <option value="before">지정 요소 바로 앞에 추가 (형제 요소)</option>
                      <option value="html">지정 요소의 내용을 대체</option>
                    </FormSelect>
                  </td>
                </tr>
                <tr>
                  <th>위젯 최대너비</th>
                  <td colSpan={2} className="text-left">
                    <FormInput name="maxWidth"
                               value={(this.metaWidget.reviewPageConfig && this.metaWidget.reviewPageConfig.maxWidth) || ''}
                               onChange={this.onChangeReviewPageConfig}
                               placeholder="예: 100%, 1200px, auto"
                               style={{maxWidth: 220}} />
                  </td>
                </tr>
                <tr>
                  <th>여백 (상단/하단/좌우)</th>
                  <td colSpan={2} className="text-left">
                    <div style={{display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap'}}>
                      <FormInput name="marginTop"
                                 value={(this.metaWidget.reviewPageConfig && this.metaWidget.reviewPageConfig.marginTop) || ''}
                                 onChange={this.onChangeReviewPageConfig}
                                 placeholder="상단"
                                 style={{width: 120}} />
                      <FormInput name="marginBottom"
                                 value={(this.metaWidget.reviewPageConfig && this.metaWidget.reviewPageConfig.marginBottom) || ''}
                                 onChange={this.onChangeReviewPageConfig}
                                 placeholder="하단"
                                 style={{width: 120}} />
                      <FormInput name="lrPadding"
                                 value={(this.metaWidget.reviewPageConfig && this.metaWidget.reviewPageConfig.lrPadding) || ''}
                                 onChange={this.onChangeReviewPageConfig}
                                 placeholder="좌우"
                                 style={{width: 120}} />
                      <span style={{fontSize: 12, color: '#9CA3AF'}}>예: 20px, 1rem</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>숨김 처리할 클래스/ID</th>
                  <td colSpan={2} className="text-left">
                    <FormInput name="hideSelector"
                               value={(this.metaWidget.reviewPageConfig && this.metaWidget.reviewPageConfig.hideSelector) || ''}
                               onChange={this.onChangeReviewPageConfig}
                               placeholder=".class1, #id1, .class2"
                               style={{maxWidth: 520}} />
                    <p style={{marginTop: 5, marginBottom: 0, fontSize: 12, color: '#6B7280'}}>
                      리뷰 게시판 페이지에서 <b>숨기고 싶은 요소</b>의 CSS selector 를 입력합니다. 쉼표(,)로 여러 개 지정 가능.<br/>
                      예: <code>.xans-board-listpackage</code>, <code>#board-header</code>, <code>.original-review-area</code>
                    </p>
                  </td>
                </tr>
                </tbody>
              </table>
              {/* 저장은 하단 sticky-save 통합 바에서 일괄 처리 */}
            </div>
            </div>
          </div>
          )}

          {/* 마이페이지 탭: 나의리뷰 위젯 === 아코디언 === */}
          {(this.activeTab === 'mypage') && (
          <div className={`wbp-accordion ${this.openSection === 'myReview' ? 'is-open' : ''}`} style={{marginTop: 16}}>
            <div className="wbp-accordion__head" onClick={() => this.toggleAccordion('myReview')}>
              <div className="wbp-accordion__title">
                <FeatherIcon icon="user-check" size="16" />
                <span>나의리뷰 위젯</span>
                <span className={`wbp-status-chip ${this.metaWidget.myReview === 'yes' ? 'is-on' : 'is-off'}`}>
                  {this.metaWidget.myReview === 'yes' ? 'ON' : 'OFF'}
                </span>
              </div>
              <div className="wbp-accordion__toggle">
                <FeatherIcon icon={this.openSection === 'myReview' ? 'chevron-up' : 'chevron-down'} size="18" />
              </div>
            </div>
            <div className="wbp-accordion__body" style={{display: this.openSection === 'myReview' ? 'block' : 'none'}}>
            <div className="section-box" style={{marginTop: 0, border: 'none', boxShadow: 'none', padding: '4px 4px 12px'}}>
              <p style={{margin: '0 0 12px', fontSize: 13, color: '#6B7280'}}>
                카페24 <b>마이페이지</b>에서 로그인한 회원에게 <b>내가 작성한 리뷰</b>와 <b>작성 가능한 리뷰</b>(구매 후 미작성) 목록을 보여줍니다.
                기본 노출 위치는 <b>마이페이지 게시판 목록</b>(<code>/myshop/board_list.html</code>)이며, 부모 선택자로 위치를 바꿀 수 있습니다.
              </p>
              <table className="s-table">
                <colgroup>
                  <col width="200px"/><col width="40%"/><col />
                </colgroup>
                <tbody>
                <tr>
                  <th>위젯 사용</th>
                  <td colSpan={2} className="text-left">
                    <div className="mw-page-check-list">
                      {[{key:'yes',label:'사용',icon:'check-circle'},{key:'no',label:'사용안함',icon:'x-circle'}].map(o => {
                        const active = (this.metaWidget.myReview || 'no') === o.key;
                        return (
                          <label key={o.key} className={`mw-page-check ${active ? 'is-checked' : ''}`}
                                 onClick={() => this.setMyReviewOnOff(o.key)}>
                            <FeatherIcon icon={o.icon} size="16" /><span>{o.label}</span>
                          </label>
                        );
                      })}
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>위젯 제목</th>
                  <td colSpan={2} className="text-left">
                    <FormInput name="title" placeholder="나의 리뷰"
                               value={(this.metaWidget.myReviewConfig && this.metaWidget.myReviewConfig.title) || ''}
                               onChange={this.onChangeMyReviewConfig} style={{maxWidth: 320}} />
                  </td>
                </tr>
                <tr>
                  <th>작성 가능한 리뷰 탭</th>
                  <td colSpan={2} className="text-left">
                    <label style={{display:'inline-flex', alignItems:'center', gap:8, cursor:'pointer'}}>
                      <FormCheckbox small toggle
                        checked={!!(this.metaWidget.myReviewConfig && this.metaWidget.myReviewConfig.showWritable)}
                        onChange={e => this.onChangeMyReviewConfig({target:{name:'showWritable', type:'checkbox', checked: e.target.checked}})} />
                      <span>구매 후 작성하지 않은 상품의 '작성 가능한 리뷰' 탭을 함께 노출</span>
                    </label>
                  </td>
                </tr>
                <tr>
                  <th>기본 탭</th>
                  <td colSpan={2} className="text-left">
                    <FormSelect name="defaultTab" style={{maxWidth: 320}}
                                value={(this.metaWidget.myReviewConfig && this.metaWidget.myReviewConfig.defaultTab) || 'written'}
                                onChange={this.onChangeMyReviewConfig}>
                      <option value="written">작성한 리뷰</option>
                      <option value="writable">작성 가능한 리뷰</option>
                    </FormSelect>
                  </td>
                </tr>
                <tr>
                  <th>페이지당 리뷰수</th>
                  <td className="text-left">
                    <FormSelect name="listCount"
                                value={(this.metaWidget.myReviewConfig && this.metaWidget.myReviewConfig.listCount) || 5}
                                onChange={this.onChangeMyReviewConfig}>
                      <option value="5">5</option><option value="10">10</option><option value="20">20</option>
                    </FormSelect>
                  </td>
                  <td className="text-left"></td>
                </tr>
                <tr>
                  <th>표시 항목</th>
                  <td colSpan={2} className="text-left">
                    <label style={{display:'inline-flex', alignItems:'center', gap:6, marginRight:18, cursor:'pointer'}}>
                      <FormCheckbox small
                        checked={!!(this.metaWidget.myReviewConfig && this.metaWidget.myReviewConfig.showRating)}
                        onChange={e => this.onChangeMyReviewConfig({target:{name:'showRating', type:'checkbox', checked: e.target.checked}})} />
                      <span>별점 표시</span>
                    </label>
                    <label style={{display:'inline-flex', alignItems:'center', gap:6, cursor:'pointer'}}>
                      <FormCheckbox small
                        checked={!!(this.metaWidget.myReviewConfig && this.metaWidget.myReviewConfig.showCount)}
                        onChange={e => this.onChangeMyReviewConfig({target:{name:'showCount', type:'checkbox', checked: e.target.checked}})} />
                      <span>리뷰 개수 표시</span>
                    </label>
                  </td>
                </tr>
                <tr>
                  <th>부모 클래스/ID (PC)</th>
                  <td colSpan={2} className="text-left">
                    <FormInput name="parentSelector"
                               value={(this.metaWidget.myReviewConfig && this.metaWidget.myReviewConfig.parentSelector) || ''}
                               onChange={this.onChangeMyReviewConfig}
                               placeholder=".class-name 또는 #element-id" style={{maxWidth: 420}} />
                    <p style={{marginTop: 5, marginBottom: 0, fontSize: 12, color: '#6B7280'}}>위젯을 넣을 부모 요소. 비우면 마이페이지 게시판 목록(<code>/myshop/board_list.html</code>)에 자동 삽입됩니다.</p>
                  </td>
                </tr>
                <tr>
                  <th>부모 클래스/ID (모바일)</th>
                  <td colSpan={2} className="text-left">
                    <FormInput name="parentSelectorMobile"
                               value={(this.metaWidget.myReviewConfig && this.metaWidget.myReviewConfig.parentSelectorMobile) || ''}
                               onChange={this.onChangeMyReviewConfig}
                               placeholder="비우면 PC 설정 사용" style={{maxWidth: 420}} />
                  </td>
                </tr>
                <tr>
                  <th>삽입 위치 (PC)</th>
                  <td colSpan={2} className="text-left">
                    <FormSelect name="insertPosition" style={{maxWidth: 320}}
                                value={(this.metaWidget.myReviewConfig && this.metaWidget.myReviewConfig.insertPosition) || 'append'}
                                onChange={this.onChangeMyReviewConfig}>
                      <option value="append">지정 요소 내부의 맨 끝에 추가</option>
                      <option value="prepend">지정 요소 내부의 맨 앞에 추가</option>
                      <option value="after">지정 요소 바로 뒤에 추가 (형제 요소)</option>
                      <option value="before">지정 요소 바로 앞에 추가 (형제 요소)</option>
                      <option value="html">지정 요소의 내용을 대체</option>
                    </FormSelect>
                  </td>
                </tr>
                <tr>
                  <th>삽입 위치 (모바일)</th>
                  <td colSpan={2} className="text-left">
                    <FormSelect name="insertPositionMobile" style={{maxWidth: 320}}
                                value={(this.metaWidget.myReviewConfig && this.metaWidget.myReviewConfig.insertPositionMobile) || ''}
                                onChange={this.onChangeMyReviewConfig}>
                      <option value="">PC와 동일</option>
                      <option value="append">지정 요소 내부의 맨 끝에 추가</option>
                      <option value="prepend">지정 요소 내부의 맨 앞에 추가</option>
                      <option value="after">지정 요소 바로 뒤에 추가 (형제 요소)</option>
                      <option value="before">지정 요소 바로 앞에 추가 (형제 요소)</option>
                      <option value="html">지정 요소의 내용을 대체</option>
                    </FormSelect>
                  </td>
                </tr>
                <tr>
                  <th>위젯 최대너비</th>
                  <td colSpan={2} className="text-left">
                    <FormInput name="maxWidth"
                               value={(this.metaWidget.myReviewConfig && this.metaWidget.myReviewConfig.maxWidth) || ''}
                               onChange={this.onChangeMyReviewConfig}
                               placeholder="예: 100%, 1200px, auto" style={{maxWidth: 220}} />
                  </td>
                </tr>
                <tr>
                  <th>여백 (상단/하단/좌우)</th>
                  <td colSpan={2} className="text-left">
                    <div style={{display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap'}}>
                      <FormInput name="marginTop" value={(this.metaWidget.myReviewConfig && this.metaWidget.myReviewConfig.marginTop) || ''} onChange={this.onChangeMyReviewConfig} placeholder="상단" style={{width: 120}} />
                      <FormInput name="marginBottom" value={(this.metaWidget.myReviewConfig && this.metaWidget.myReviewConfig.marginBottom) || ''} onChange={this.onChangeMyReviewConfig} placeholder="하단" style={{width: 120}} />
                      <FormInput name="lrPadding" value={(this.metaWidget.myReviewConfig && this.metaWidget.myReviewConfig.lrPadding) || ''} onChange={this.onChangeMyReviewConfig} placeholder="좌우" style={{width: 120}} />
                      <span style={{fontSize: 12, color: '#9CA3AF'}}>예: 20px, 1rem</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>숨김 처리할 클래스/ID</th>
                  <td colSpan={2} className="text-left">
                    <FormInput name="hideSelector"
                               value={(this.metaWidget.myReviewConfig && this.metaWidget.myReviewConfig.hideSelector) || ''}
                               onChange={this.onChangeMyReviewConfig}
                               placeholder=".class1, #id1, .class2" style={{maxWidth: 520}} />
                    <p style={{marginTop: 5, marginBottom: 0, fontSize: 12, color: '#6B7280'}}>마이페이지에서 숨기고 싶은 카페24 기본 요소의 CSS selector. 쉼표(,)로 여러 개 지정 가능.</p>
                  </td>
                </tr>
                </tbody>
              </table>
              {/* 저장은 하단 sticky-save 통합 바에서 일괄 처리 */}
            </div>
            </div>
          </div>
          )}

          {/* 리뷰 작성 유도 위젯: 다중 페이지 탭 === A-1 아코디언 === */}
          {(this.activeTab === 'multi') && (
          <div className={`wbp-accordion ${this.openSection === 'reviewable' ? 'is-open' : ''} ${this.dirtyFlags.reviewable ? 'is-dirty' : ''}`} style={{marginTop: 16}}>
            <div className="wbp-accordion__head" onClick={() => this.toggleAccordion('reviewable')}>
              <div className="wbp-accordion__title">
                <FeatherIcon icon="edit-3" size="16" />
                <span>리뷰 작성 유도 위젯</span>
                <span className={`wbp-status-chip ${this.metaWidget.reviewableList === 'yes' ? 'is-on' : 'is-off'}`}>
                  {this.metaWidget.reviewableList === 'yes' ? 'ON' : 'OFF'}
                </span>
                {this.dirtyFlags.reviewable && <span className="wbp-dirty-dot" title="미저장 변경사항"></span>}
                <button type="button" className="wbp-accordion__sample-btn"
                        onClick={(e) => this.openPreviewSample('reviewable', e)}
                        title="예제 이미지 보기">
                  <FeatherIcon icon="image" size="13" /> 예제 보기
                </button>
              </div>
              <div className="wbp-accordion__toggle">
                <FeatherIcon icon={this.openSection === 'reviewable' ? 'chevron-up' : 'chevron-down'} size="18" />
              </div>
            </div>
            <div className="wbp-accordion__body" style={{display: this.openSection === 'reviewable' ? 'block' : 'none'}}>
            <div className="section-box" style={{marginTop: 0, border: 'none', boxShadow: 'none', padding: '4px 4px 12px'}}>
              <table className="s-table">
                <colgroup>
                  <col width="200px"/><col width=""/><col/>
                </colgroup>
                <tbody>
                <tr>
                  <th>알림 위젯 사용</th>
                  <td colSpan={2} className="text-left">
                    {/* C-1: 토글 스위치로 변경 */}
                    <FormCheckbox toggle small
                      checked={this.metaWidget.reviewableList === "yes"}
                      onChange={this.toggleReviewableList}>
                      {this.metaWidget.reviewableList === 'yes' ? '사용함' : '사용안함'}
                    </FormCheckbox>
                  </td>
                </tr>
                <tr>
                  <th>알림 페이지 추가</th>
                  <td colSpan={2} className="text-left">
                    <div style={{display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '10px'}}>
                      <FormSelect value={this.selectedPage} onChange={(e) => this.selectedPage = e.target.value} style={{width: '200px'}}>
                        <option value="">선택하세요</option>
                        <option value="order">마이페이지</option>
                        <option value="main">메인페이지</option>
                        <option value="product">상품 상세페이지</option>
                      </FormSelect>
                      <Button size="sm" theme="primary" onClick={this.addReviewablePage}>추가</Button>
                    </div>
                    {this.metaWidget.reviewableListConfig.pages && this.metaWidget.reviewableListConfig.pages.length > 0 && (
                      <div style={{marginTop: '15px'}}>
                        <strong>선택된 페이지:</strong>
                        <div style={{display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px'}}>
                          {this.metaWidget.reviewableListConfig.pages.map((page, idx) => (
                            <div key={idx} style={{display:'inline-flex',alignItems:'center',gap:'6px',padding:'6px 12px',background:'#f5f5f5',borderRadius:'4px',fontSize:'14px'}}>
                              <span>
                                {page === 'order' && '마이페이지'}
                                {page === 'main' && '메인페이지'}
                                {page === 'product' && '상품 상세페이지'}
                              </span>
                              <button onClick={() => this.removeReviewablePage(page)}
                                style={{background:'none',border:'none',cursor:'pointer',padding:'0',color:'#999',fontSize:'16px'}}>
                                ×
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </td>
                </tr>
                <tr>
                  <th>
                    닫기 후 재 노출 시간
                    {/* C-4: 설명을 툴팁 아이콘으로 */}
                    <span className="wbp-help" title="사용자가 위젯을 닫은 후 다시 표시되기까지의 시간 (1~720시간)">
                      <FeatherIcon icon="help-circle" size="13" />
                    </span>
                  </th>
                  <td colSpan={2} className="text-left">
                    <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                      {/* C-3: 숫자 + 슬라이더 조합 */}
                      <input type="range" min="1" max="720" step="1"
                        value={this.metaWidget.reviewableListConfig.reShowDelay || 24}
                        onChange={(e) => { this.metaWidget.reviewableListConfig.reShowDelay = parseInt(e.target.value); this.dirtyFlags.reviewable = true; }}
                        className="wbp-range" style={{flex: 1, maxWidth: '320px'}} />
                      <FormInput type="number" name="reShowDelay" min="1" max="720"
                        value={this.metaWidget.reviewableListConfig.reShowDelay}
                        onChange={(event) => { this.onChangeReviewableConfig(event); }}
                        style={{width: '90px'}} />
                      <span style={{fontSize: '13px', color: '#495057'}}>시간 후</span>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            </div>
          </div>
          )}

          {/* 실시간 리뷰 위젯: 다중 페이지 탭 === A-1 아코디언 === */}
          {(this.activeTab === 'multi') && (
          <div className={`wbp-accordion ${this.openSection === 'realtime' ? 'is-open' : ''} ${this.dirtyFlags.realtime ? 'is-dirty' : ''}`} style={{marginTop: 16}}>
            <div className="wbp-accordion__head" onClick={() => this.toggleAccordion('realtime')}>
              <div className="wbp-accordion__title">
                <FeatherIcon icon="zap" size="16" />
                <span>실시간 리뷰 위젯</span>
                <span className="wbp-new-chip">NEW</span>
                <span className={`wbp-status-chip ${this.metaWidget.realtimeReview === 'yes' ? 'is-on' : 'is-off'}`}>
                  {this.metaWidget.realtimeReview === 'yes' ? 'ON' : 'OFF'}
                </span>
                {this.dirtyFlags.realtime && <span className="wbp-dirty-dot" title="미저장 변경사항"></span>}
                <button type="button" className="wbp-accordion__sample-btn"
                        onClick={(e) => this.openPreviewSample('realtime', e)}
                        title="예제 이미지 보기">
                  <FeatherIcon icon="image" size="13" /> 예제 보기
                </button>
              </div>
              <div className="wbp-accordion__toggle">
                <FeatherIcon icon={this.openSection === 'realtime' ? 'chevron-up' : 'chevron-down'} size="18" />
              </div>
            </div>
            <div className="wbp-accordion__body" style={{display: this.openSection === 'realtime' ? 'block' : 'none'}}>
            <div className="section-box" style={{marginTop: 0, border: 'none', boxShadow: 'none', padding: '4px 4px 12px'}}>
              <table className="s-table">
                <colgroup>
                  <col width="200px"/><col width=""/><col/>
                </colgroup>
                <tbody>
                <tr>
                  <th>실시간 리뷰 위젯 사용</th>
                  <td colSpan={2} className="text-left">
                    <FormCheckbox toggle small
                      checked={this.metaWidget.realtimeReview === "yes"}
                      onChange={this.toggleRealtimeReview}>
                      {this.metaWidget.realtimeReview === 'yes' ? '사용함' : '사용안함'}
                    </FormCheckbox>
                  </td>
                </tr>
                <tr>
                  <th>부모 클래스/ID</th>
                  <td colSpan={2} className="text-left">
                    <FormInput name="parentSelector"
                               value={(this.metaWidget.realtimeReviewConfig && this.metaWidget.realtimeReviewConfig.parentSelector) || ''}
                               onChange={this.onChangeRealtimeReviewConfig}
                               placeholder=".class-name 또는 #element-id"
                               style={{maxWidth: 420}} />
                    <p style={{marginTop: 5, marginBottom: 0, fontSize: 12, color: '#6B7280'}}>예: <code>.review-container</code>, <code>#review-wrap</code></p>
                  </td>
                </tr>
                <tr>
                  <th>위젯 삽입 위치</th>
                  <td colSpan={2} className="text-left">
                    <FormSelect name="insertPosition"
                                value={(this.metaWidget.realtimeReviewConfig && this.metaWidget.realtimeReviewConfig.insertPosition) || 'append'}
                                onChange={this.onChangeRealtimeReviewConfig}
                                style={{maxWidth: 320}}>
                      <option value="append">지정 요소 내부의 맨 끝에 추가</option>
                      <option value="prepend">지정 요소 내부의 맨 앞에 추가</option>
                      <option value="after">지정 요소 바로 뒤에 추가 (형제 요소)</option>
                      <option value="before">지정 요소 바로 앞에 추가 (형제 요소)</option>
                      <option value="html">지정 요소의 내용을 대체</option>
                    </FormSelect>
                  </td>
                </tr>
                <tr>
                  <th>제목</th>
                  <td colSpan={2} className="text-left">
                    <FormInput
                      name="title"
                      value={this.metaWidget.realtimeReviewConfig.title || '실시간 리뷰'}
                      onChange={this.onChangeRealtimeReviewConfig}
                      placeholder="실시간 리뷰"
                      style={{width: '300px'}}
                    />
                  </td>
                </tr>
                <tr>
                  <th>디자인</th>
                  <td colSpan={2} className="text-left">
                    {/* D-2: 디자인 선택 카드형 */}
                    <div className="wbp-design-picker">
                      {[
                        {key: 'bubble', label: '말풍선', icon: 'message-circle'},
                        {key: 'slide', label: '슬라이드', icon: 'layers'},
                        {key: 'ticker', label: '틱커', icon: 'minus'}
                      ].map(d => {
                        const currentDesign = this.metaWidget.realtimeReviewConfig.designType || 'slide';
                        const active = currentDesign === d.key;
                        return (
                          <div key={d.key}
                               className={`wbp-design-card ${active ? 'is-active' : ''}`}
                               onClick={() => this.onChangeRealtimeReviewConfig({target:{name:"designType",value:d.key,type:"text"}})}>
                            <div className="wbp-design-card__preview">
                              <FeatherIcon icon={d.icon} size="24" />
                            </div>
                            <div className="wbp-design-card__label">{d.label}</div>
                            {active && <div className="wbp-design-card__check"><FeatherIcon icon="check" size="14" /></div>}
                          </div>
                        );
                      })}
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>페이지 추가</th>
                  <td colSpan={2} className="text-left">
                    <div style={{display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '10px'}}>
                      <FormSelect value={this.selectedRealtimePage} onChange={(e) => this.selectedRealtimePage = e.target.value} style={{width: '200px'}}>
                        <option value="">선택하세요</option>
                        <option value="main">메인페이지</option>
                        <option value="category">카테고리페이지</option>
                        <option value="product">상품 상세페이지</option>
                      </FormSelect>
                      <Button size="sm" theme="primary" onClick={this.addRealtimePage}>추가</Button>
                    </div>
                    {this.metaWidget.realtimeReviewConfig.pages && this.metaWidget.realtimeReviewConfig.pages.length > 0 && (
                        <div style={{marginTop: '15px'}}>
                          <strong>선택된 페이지:</strong>
                          <div style={{display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px'}}>
                            {this.metaWidget.realtimeReviewConfig.pages.map((page, idx) => (
                                <div key={idx} style={{display:'inline-flex',alignItems:'center',gap:'6px',padding:'6px 12px',background:'#f5f5f5',borderRadius:'4px',fontSize:'14px'}}>
                              <span>
                                {page === 'main' && '메인페이지'}
                                {page === 'category' && '카테고리페이지'}
                                {page === 'product' && '상품 상세페이지'}
                              </span>
                                  <button onClick={() => this.removeRealtimePage(page)}
                                          style={{background:'none',border:'none',cursor:'pointer',padding:'0',color:'#999',fontSize:'16px'}}>
                                    ×
                                  </button>
                                </div>
                            ))}
                          </div>
                        </div>
                    )}
                  </td>
                </tr>
                <tr>
                  <th>최대 노출 리뷰 수</th>
                  <td colSpan={2} className="text-left">
                    <FormSelect value={this.metaWidget.realtimeReviewConfig.displayCount} name="displayCount"
                      onChange={this.onChangeRealtimeReviewConfig} style={{width: '120px'}}>
                      <option value="3">3개</option>
                      <option value="5">5개</option>
                      <option value="10">10개</option>
                      <option value="15">15개</option>
                      <option value="20">20개</option>
                    </FormSelect>
                  </td>
                </tr>
                <tr>
                  <th>노출할 리뷰 작성 기간</th>
                  <td colSpan={2} className="text-left">
                    <FormSelect value={this.metaWidget.realtimeReviewConfig.displayPeriod || 'today'} name="displayPeriod"
                                onChange={this.onChangeRealtimeReviewConfig} style={{width: '160px'}}>
                      <option value="today">오늘 작성된 리뷰</option>
                      <option value="1h">최근 1시간</option>
                      <option value="3h">최근 3시간</option>
                      <option value="6h">최근 6시간</option>
                      <option value="1d">최근 1일</option>
                      <option value="1w">최근 1주</option>
                      <option value="1m">최근 1달</option>
                      <option value="latest">(기간 제한 없이)최신 리뷰</option>
                      <option value="grade">(기간 제한 없이)높은 별점</option>
                    </FormSelect>
                    <p style={{marginTop:'5px',fontSize:'12px',color:'#666'}}>
                      선택한 기간 내 작성된 리뷰만 실시간 위젯에 노출됩니다.
                    </p>
                  </td>
                </tr>
                <tr>
                  <th>
                    전환 속도
                    <span className="wbp-help" title="리뷰 한 건당 노출 시간 (1000~10000ms)"><FeatherIcon icon="help-circle" size="13" /></span>
                  </th>
                  <td colSpan={2} className="text-left">
                    {/* D-4: 슬라이더 + 숫자 + 사람 읽기 쉬운 포맷 */}
                    <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                      <input type="range" min="1000" max="10000" step="500"
                        value={this.metaWidget.realtimeReviewConfig.displayDelay || 3000}
                        onChange={(e) => this.onChangeRealtimeReviewConfig({target:{name:'displayDelay', value: e.target.value, type:'text'}})}
                        className="wbp-range" style={{flex: 1, maxWidth: '320px'}} />
                      <FormInput type="number" name="displayDelay" min="1000" max="10000"
                        value={this.metaWidget.realtimeReviewConfig.displayDelay}
                        onChange={this.onChangeRealtimeReviewConfig}
                        style={{width: '120px'}} />
                      <span style={{fontSize: '13px', color: '#495057', whiteSpace: 'nowrap'}}>
                        ms · <strong>약 {((this.metaWidget.realtimeReviewConfig.displayDelay || 3000)/1000).toFixed(1)}초</strong>
                      </span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>리뷰 데이터 노출 표시</th>
                  <td colSpan={2} className="text-left">
                    {/* D-3: 시각적 카드형 체크박스 */}
                    <div className="wbp-check-card-group">
                      {[
                        {flag: 'showUserId', label: '사용자 ID', icon: 'user'},
                        {flag: 'showDate', label: '작성 날짜', icon: 'calendar'},
                        {flag: 'showRating', label: '별점', icon: 'star'}
                      ].map(o => {
                        const active = this.metaWidget.realtimeReviewConfig[o.flag] !== false;
                        return (
                          <div key={o.flag}
                               className={`wbp-check-card ${active ? 'is-active' : ''}`}
                               onClick={() => this.toggleRealtimeShowFlag(o.flag)}>
                            <FeatherIcon icon={o.icon} size="18" />
                            <span className="wbp-check-card__label">{o.label}</span>
                            <span className="wbp-check-card__status">{active ? '노출' : '미노출'}</span>
                          </div>
                        );
                      })}
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>
                    닫기 후 재 노출 시간
                    <span className="wbp-help" title="0 = 새로고침 시 다시 표시, 0~720시간"><FeatherIcon icon="help-circle" size="13" /></span>
                  </th>
                  <td colSpan={2} className="text-left">
                    <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                      <input type="range" min="0" max="720" step="1"
                        value={this.metaWidget.realtimeReviewConfig.reShowDelay != null ? this.metaWidget.realtimeReviewConfig.reShowDelay : 24}
                        onChange={(e) => this.onChangeRealtimeReviewConfig({target:{name:'reShowDelay', value: e.target.value, type:'text'}})}
                        className="wbp-range" style={{flex: 1, maxWidth: '320px'}} />
                      <FormInput type="number" name="reShowDelay" min="0" max="720"
                        value={this.metaWidget.realtimeReviewConfig.reShowDelay != null ? this.metaWidget.realtimeReviewConfig.reShowDelay : 24}
                        onChange={this.onChangeRealtimeReviewConfig}
                        style={{width: '90px'}} />
                      <span style={{fontSize: '13px', color: '#495057'}}>시간 후</span>
                    </div>
                  </td>
                </tr>

                </tbody>
              </table>
            </div>
            </div>
          </div>
          )}

          {/* === 실시간 주문 위젯 (다중 페이지 탭 전용) === */}
          {(this.activeTab === 'multi') && (() => {
            const cfg = this.metaWidget.purchaseReviewConfig || {};
            const isOn = this.metaWidget.purchaseReview === 'yes';
            return (
            <div className={`wbp-accordion ${this.openSection === 'purchaseReview' ? 'is-open' : ''} ${this.dirtyFlags.purchaseReview ? 'is-dirty' : ''}`} style={{marginTop: 16}}>
              <div className="wbp-accordion__head" onClick={() => this.toggleAccordion('purchaseReview')}>
                <div className="wbp-accordion__title">
                  <FeatherIcon icon="shopping-cart" size="16" />
                  <span>실시간 주문 위젯</span>
                  <span className="wbp-new-chip">NEW</span>
                  <span className={`wbp-status-chip ${isOn ? 'is-on' : 'is-off'}`}>
                    {isOn ? 'ON' : 'OFF'}
                  </span>
                  {this.dirtyFlags.purchaseReview && <span className="wbp-dirty-dot" title="미저장 변경사항"></span>}
                  <button type="button" className="wbp-accordion__sample-btn"
                          onClick={(e) => this.openPreviewSample('purchaseReview', e)}
                          title="예제 이미지 보기">
                    <FeatherIcon icon="image" size="13" /> 예제 보기
                  </button>
                </div>
                <div className="wbp-accordion__toggle">
                  <FeatherIcon icon={this.openSection === 'purchaseReview' ? 'chevron-up' : 'chevron-down'} size="18" />
                </div>
              </div>
              <div className="wbp-accordion__body" style={{display: this.openSection === 'purchaseReview' ? 'block' : 'none'}}>
                <div className="section-box" style={{marginTop: 0, border: 'none', boxShadow: 'none', padding: '4px 4px 12px'}}>
                  <table className="s-table">
                    <colgroup><col width="200px"/><col width=""/></colgroup>
                    <tbody>
                      <tr>
                        <th>실시간 주문 위젯 사용</th>
                        <td className="text-left">
                          <FormCheckbox toggle small checked={isOn} onChange={this.togglePurchaseReview}>
                            {isOn ? '사용함' : '사용안함'}
                          </FormCheckbox>
                          <p style={{marginTop:'6px',fontSize:'12px',color:'#666'}}>
                            최근 주문을 순차적으로 노출하고 상품별 리뷰 1건을 페어링합니다. 주문이 적은 쇼핑몰도 활성화된 것으로 보이게 신뢰도를 연출합니다.
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <th>타이틀</th>
                        <td className="text-left">
                          <FormInput name="title" value={cfg.title || ''} onChange={this.onChangePurchaseReviewConfig} placeholder="예) 지금 주문되고 있어요" style={{width: '320px'}}/>
                        </td>
                      </tr>
                      <tr>
                        <th>노출 페이지</th>
                        <td className="text-left">
                          <div className="mw-page-check-list">
                            {[
                              {key: 'main', label: '메인페이지 (전체 상품)', icon: 'home', flag: 'enableMain'},
                              {key: 'category', label: '카테고리 페이지 (카테고리 상품)', icon: 'list', flag: 'enableCategory'},
                              {key: 'detail', label: '상품 상세 페이지 (해당 상품)', icon: 'shopping-bag', flag: 'enableDetail'}
                            ].map(p => {
                              const checked = cfg[p.flag] !== false;
                              return (
                                <label key={p.key} className={`mw-page-check ${checked ? 'is-checked' : ''}`}>
                                  <input type="checkbox" checked={checked} onChange={() => this.togglePurchaseScope(p.key)} />
                                  <FeatherIcon icon={p.icon} size="16" />
                                  <span>{p.label}</span>
                                </label>
                              );
                            })}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>디자인</th>
                        <td className="text-left">
                          <div className="wbp-design-picker">
                            {[
                              {key: 'ticker', label: '틱커 (가로)', icon: 'minus'},
                              {key: 'card', label: '카드 (순차)', icon: 'square'},
                              {key: 'bubble', label: '말풍선', icon: 'message-circle'}
                            ].map(d => {
                              const cur = cfg.designType || 'ticker';
                              const active = cur === d.key;
                              return (
                                <div key={d.key}
                                     className={`wbp-design-card ${active ? 'is-active' : ''}`}
                                     onClick={() => this.changePurchaseDesignType(d.key)}>
                                  <div className="wbp-design-card__preview"><FeatherIcon icon={d.icon} size="24" /></div>
                                  <div className="wbp-design-card__label">{d.label}</div>
                                  {active && <div className="wbp-design-card__check"><FeatherIcon icon="check" size="14" /></div>}
                                </div>
                              );
                            })}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>노출 위치</th>
                        <td className="text-left">
                          {(() => {
                            const dt = cfg.designType || 'ticker';
                            const isTicker = dt === 'ticker';
                            const opts = isTicker
                              ? [{v:'top', label:'상단'}, {v:'bottom', label:'하단 (기본)'}]
                              : [
                                  {v:'top-left', label:'상단 왼쪽'},
                                  {v:'top-right', label:'상단 오른쪽'},
                                  {v:'bottom-left', label:'하단 왼쪽 (기본)'},
                                  {v:'bottom-right', label:'하단 오른쪽'}
                                ];
                            const def = isTicker ? 'bottom' : 'bottom-left';
                            return (
                              <FormSelect name="position" value={cfg.position || def} onChange={this.onChangePurchaseReviewConfig} style={{width: '200px'}}>
                                {opts.map(o => <option key={o.v} value={o.v}>{o.label}</option>)}
                              </FormSelect>
                            );
                          })()}
                          <div style={{fontSize: '12px', color: '#6c757d', marginTop: '4px'}}>
                            {(cfg.designType || 'ticker') === 'ticker'
                              ? '틱커는 화면 가로 폭 전체로 노출되며 상단/하단 위치만 선택할 수 있습니다.'
                              : '카드/말풍선은 화면 모서리에 작게 떠 있는 형태로 노출됩니다.'}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>조회 기간</th>
                        <td className="text-left">
                          <FormSelect name="periodHours" value={cfg.periodHours || 24} onChange={this.onChangePurchaseReviewConfig} style={{width: '160px'}}>
                            <option value="6">최근 6시간</option>
                            <option value="12">최근 12시간</option>
                            <option value="24">최근 1일</option>
                            <option value="48">최근 2일</option>
                            <option value="72">최근 3일</option>
                            <option value="168">최근 7일</option>
                            <option value="360">최근 15일</option>
                            <option value="720">최근 30일</option>
                          </FormSelect>
                        </td>
                      </tr>
                      <tr>
                        <th>데이터 부족 시 확장</th>
                        <td className="text-left">
                          <FormSelect name="extendHours" value={cfg.extendHours || 72} onChange={this.onChangePurchaseReviewConfig} style={{width: '160px'}}>
                            <option value="24">최대 1일</option>
                            <option value="48">최대 2일</option>
                            <option value="72">최대 3일</option>
                            <option value="168">최대 7일</option>
                            <option value="360">최대 15일</option>
                            <option value="720">최대 30일</option>
                            <option value="1440">최대 60일</option>
                            <option value="2160">최대 90일</option>
                            <option value="4320">최대 180일</option>
                            <option value="8640">최대 360일</option>
                            <option value="0">확장 안 함</option>
                          </FormSelect>
                        </td>
                      </tr>
                      <tr>
                        <th>최소/최대 노출 건수</th>
                        <td className="text-left">
                          <div style={{display:'flex', gap: '8px', alignItems: 'center'}}>
                            <FormSelect name="minDisplayCount" value={cfg.minDisplayCount || 5} onChange={this.onChangePurchaseReviewConfig} style={{width: '100px'}}>
                              {[1,3,5,7,10].map(n => <option key={n} value={n}>{n}건</option>)}
                            </FormSelect>
                            <span style={{color:'#6c757d',fontSize:'12px'}}>~</span>
                            <FormSelect name="displayCount" value={cfg.displayCount || 10} onChange={this.onChangePurchaseReviewConfig} style={{width: '100px'}}>
                              {[5,10,15,20,30].map(n => <option key={n} value={n}>{n}건</option>)}
                            </FormSelect>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>순차 노출 간격</th>
                        <td className="text-left">
                          <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                            <input type="range" min="1000" max="10000" step="500"
                              value={cfg.rotationDelay || 4000}
                              onChange={(e) => this.onChangePurchaseReviewConfig({target:{name:'rotationDelay', value: e.target.value, type:'text'}})}
                              className="wbp-range" style={{flex: 1, maxWidth: '280px'}} />
                            <FormInput type="number" name="rotationDelay" min="1000" max="10000"
                              value={cfg.rotationDelay || 4000}
                              onChange={this.onChangePurchaseReviewConfig}
                              style={{width: '90px'}} />
                            <span style={{fontSize:'13px',color:'#495057'}}>ms · <strong>약 {((cfg.rotationDelay || 4000)/1000).toFixed(1)}초</strong></span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>표시 옵션</th>
                        <td className="text-left">
                          <div className="wbp-check-card-group">
                            {[
                              {flag: 'showReview',       label: '리뷰 페어링',     icon: 'message-square'},
                              {flag: 'showReviewWriter', label: '리뷰 작성자 표시', icon: 'user-check'},
                              {flag: 'showBuyerName',    label: '구매자 이름 표시', icon: 'user'},
                              {flag: 'showTime',         label: '시간 표시',       icon: 'clock'}
                            ].map(o => {
                              const active = cfg[o.flag] !== false;   // 미정의 = ON
                              return (
                                <div key={o.flag}
                                     className={`wbp-check-card ${active ? 'is-active' : ''}`}
                                     onClick={() => this.togglePurchaseBoolean(o.flag)}>
                                  <FeatherIcon icon={o.icon} size="18" />
                                  <span className="wbp-check-card__label">{o.label}</span>
                                  <span className="wbp-check-card__status">{active ? '사용' : '미사용'}</span>
                                </div>
                              );
                            })}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>닫기 후 재노출</th>
                        <td className="text-left">
                          <FormSelect name="reShowDelay" value={cfg.reShowDelay !== undefined ? cfg.reShowDelay : 24}
                            onChange={this.onChangePurchaseReviewConfig}
                            style={{maxWidth: '240px'}}>
                            <option value={0}>매 페이지 노출 (0시간)</option>
                            <option value={6}>6시간 후 재노출</option>
                            <option value={24}>24시간 후 재노출 (권장)</option>
                            <option value={72}>3일 후 재노출</option>
                            <option value={168}>7일 후 재노출</option>
                          </FormSelect>
                          <p className="text-muted mt-1" style={{fontSize: 12}}>
                            사용자가 닫기(✕) 클릭 시 일정 시간 동안 위젯을 다시 보여주지 않습니다.
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <th>다양한 상품 우선 노출</th>
                        <td className="text-left">
                          <div className={`wbp-check-card ${cfg.uniqueProduct === true ? 'is-active' : ''}`}
                               onClick={() => this.togglePurchaseBoolean('uniqueProduct')}
                               style={{maxWidth: 320}}>
                            <FeatherIcon icon="grid" size="18" />
                            <span className="wbp-check-card__label">중복 상품 제거</span>
                            <span className="wbp-check-card__status">{cfg.uniqueProduct === true ? '사용' : '미사용'}</span>
                          </div>
                          <p className="text-muted mt-1" style={{fontSize: 12}}>
                            같은 상품 주문은 1회만 노출하여 다양한 상품을 보여줍니다.
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <th>리뷰 매칭 방식</th>
                        <td className="text-left">
                          <FormSelect name="matchMode" value={cfg.matchMode || 'round_robin'}
                                      onChange={this.onChangePurchaseReviewConfig}
                                      style={{maxWidth: 240}}>
                            <option value="round_robin">기본 순환 (Round-Robin)</option>
                            <option value="random">랜덤</option>
                            <option value="rating_high">별점 높은 순</option>
                            <option value="rating_diverse">별점 분산</option>
                          </FormSelect>
                          <p className="text-muted mt-1" style={{fontSize: 12}}>
                            같은 상품이 반복 노출될 때 리뷰 풀에서 선택하는 방식입니다.
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <th>리뷰 풀 크기</th>
                        <td className="text-left">
                          <FormSelect name="reviewPoolSize" value={cfg.reviewPoolSize || 5}
                                      onChange={this.onChangePurchaseReviewConfig}
                                      style={{maxWidth: 200}}>
                            <option value={3}>3건</option>
                            <option value={5}>5건 (권장)</option>
                            <option value={10}>10건</option>
                          </FormSelect>
                          <p className="text-muted mt-1" style={{fontSize: 12}}>
                            상품별로 가져올 최신 리뷰 개수입니다. 큰 값일수록 다양한 리뷰가 노출됩니다.
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <th>최소 별점 필터</th>
                        <td className="text-left">
                          <FormSelect name="minRating" value={cfg.minRating || 0}
                                      onChange={this.onChangePurchaseReviewConfig}
                                      style={{maxWidth: 200}}>
                            <option value={0}>전체 리뷰</option>
                            <option value={3}>3★ 이상</option>
                            <option value={4}>4★ 이상</option>
                            <option value={5}>5★ 만</option>
                          </FormSelect>
                          <p className="text-muted mt-1" style={{fontSize: 12}}>
                            설정 별점 이상의 리뷰만 위젯에 노출합니다.
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <th>부모 클래스/ID</th>
                        <td className="text-left">
                          <FormInput name="parentSelector" value={cfg.parentSelector || ''} onChange={this.onChangePurchaseReviewConfig}
                            placeholder=".class-name 또는 #element-id (비워두면 자동 배치)"
                            style={{width: '100%', maxWidth: '480px'}}/>
                        </td>
                      </tr>
                      <tr>
                        <th>위젯 삽입 위치</th>
                        <td className="text-left">
                          <FormSelect name="insertPosition" value={cfg.insertPosition || 'append'} onChange={this.onChangePurchaseReviewConfig} style={{width: '260px'}}>
                            <option value="append">지정 요소 내부 맨 끝에 추가</option>
                            <option value="prepend">지정 요소 내부 맨 앞에 추가</option>
                            <option value="after">지정 요소 바로 뒤 (형제)</option>
                            <option value="before">지정 요소 바로 앞 (형제)</option>
                            <option value="html">지정 요소의 내용을 교체</option>
                          </FormSelect>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            );
          })()}

        </div>

        {/* === A-3: Sticky 저장 바 (모든 섹션 통합, dirty 있을 때만 노출) === */}
        {this.hasUnsaved && (
          <div className="wbp-sticky-save wbp-sticky-save--top">
            <div className="wbp-sticky-save__msg">
              <FeatherIcon icon="alert-circle" size="16" />
              <span><strong>{this.dirtySections.length}개 섹션</strong>에 저장되지 않은 변경사항이 있습니다.</span>
              <span className="wbp-sticky-save__tags">
                {this.dirtySections.map(sec => (
                  <span key={sec} className="wbp-sticky-save__tag">{this.SECTION_LABELS[sec]}</span>
                ))}
              </span>
            </div>
            <div className="wbp-sticky-save__actions">
              <Button theme="light" size="sm" onClick={this.revertAllDirty}>되돌리기</Button>
              <Button theme="primary" size="sm" onClick={this.saveAllDirty}>변경사항 저장</Button>
            </div>
          </div>
        )}

        {/* === B-3: 삭제 확인 모달 === */}
        <Modal open={this.modals.isDeleteConfirm} toggle={this.cancelRemoveWidget} centered>
          <ModalHeader toggle={this.cancelRemoveWidget}>위젯 삭제 확인</ModalHeader>
          <ModalBody>
            <div style={{padding: '8px 0'}}>
              <div style={{fontSize: '15px', marginBottom: '8px'}}>
                정말 삭제하시겠습니까?
              </div>
              {this.pendingDeleteWidget && (
                <div style={{fontSize: '13px', color: '#6c757d', padding: '12px', background: '#f8f9fa', borderRadius: '6px', marginTop: '12px'}}>
                  <strong>{this.pendingDeleteWidget.title || '제목 없음'}</strong>
                  {this.pendingDeleteWidget.displayArea && <div style={{marginTop: '4px'}}>노출 영역: {this.pendingDeleteWidget.displayArea}</div>}
                </div>
              )}
              <div style={{fontSize: '12px', color: '#dc3545', marginTop: '12px'}}>
                ⚠ 삭제된 위젯은 복구할 수 없습니다.
              </div>
            </div>
            <div style={{display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '16px'}}>
              <Button theme="light" onClick={this.cancelRemoveWidget}>취소</Button>
              <Button theme="danger" onClick={this.confirmRemoveWidget}>삭제</Button>
            </div>
          </ModalBody>
        </Modal>


        {/* 리뷰 인사이트 세부 설정 모달 */}
        <Modal className='isReviewInsightSetting' open={this.modals.isReviewInsightSetting} toggle={() => {}} size="lg">
          <ModalHeader toggle={() => this.metaModalToggle('isReviewInsightSetting')}>리뷰 인사이트 세부 설정</ModalHeader>
          <ModalBody>
            <table className="modal-table">
              <colgroup><col width="200px"/><col width=""/></colgroup>
              <tbody>
              <tr><th>부모 클래스/ID</th><td>
                <InputGroup><FormInput name="parentSelector" value={this.metaWidget.reviewInsightConfig.parentSelector || ''} onChange={this.onChangeReviewInsightConfig} placeholder=".class-name 또는 #element-id" /></InputGroup>
                <p style={{marginTop:'5px',fontSize:'12px',color:'#666'}}>예: .review-container, #review-wrap</p>
              </td></tr>
              <tr><th>위젯 삽입 위치</th><td>
                <FormSelect name="insertPosition" value={this.metaWidget.reviewInsightConfig.insertPosition || 'append'} onChange={this.onChangeReviewInsightConfig}>
                  <option value="append">지정 요소 내부의 맨 끝에 추가</option><option value="prepend">지정 요소 내부의 맨 앞에 추가</option>
                  <option value="after">지정 요소 바로 뒤에 추가 (형제 요소)</option><option value="before">지정 요소 바로 앞에 추가 (형제 요소)</option>
                  <option value="html">지정 요소의 내용을 대체</option>
                </FormSelect>
              </td></tr>
              <tr><th>위젯 최대너비</th><td><InputGroup><FormInput name="maxWidth" value={this.metaWidget.reviewInsightConfig.maxWidth} onChange={this.onChangeReviewInsightConfig} /></InputGroup><p style={{marginTop:'5px',fontSize:'12px',color:'#666'}}>예: 100%, 1200px, auto</p></td></tr>
              <tr><th>상단여백</th><td><InputGroup><FormInput name="marginTop" value={this.metaWidget.reviewInsightConfig.marginTop} onChange={this.onChangeReviewInsightConfig} /></InputGroup></td></tr>
              <tr><th>하단여백</th><td><InputGroup><FormInput name="marginBottom" value={this.metaWidget.reviewInsightConfig.marginBottom} onChange={this.onChangeReviewInsightConfig} /></InputGroup></td></tr>
              <tr><th>좌우여백</th><td><InputGroup><FormInput name="lrPadding" value={this.metaWidget.reviewInsightConfig.lrPadding} onChange={this.onChangeReviewInsightConfig} /></InputGroup></td></tr>
              <tr><th>리뷰 별점 노출</th><td><FormCheckbox name="showRating" checked={this.metaWidget.reviewInsightConfig.showRating} onChange={this.onChangeReviewInsightConfig}>별점 표시</FormCheckbox></td></tr>
              <tr><th>카운트 노출</th><td><FormCheckbox name="showCount" checked={this.metaWidget.reviewInsightConfig.showCount} onChange={this.onChangeReviewInsightConfig}>카운트 표시</FormCheckbox></td></tr>
              </tbody>
            </table>
            <div className="btn-save" style={{marginTop:'20px',textAlign:'right'}}><Button className="save-button" onClick={this.saveReviewInsightConfig}>저장</Button></div>
          </ModalBody>
        </Modal>

        {/* 별점 및 리뷰수 세부 설정 모달 */}
        <Modal className='isReviewRatingCountSetting' open={this.modals.isReviewRatingCountSetting} toggle={() => {}} size="lg">
          <ModalHeader toggle={() => this.metaModalToggle('isReviewRatingCountSetting')}>별점 및 리뷰수 세부 설정</ModalHeader>
          <ModalBody>
            <table className="modal-table">
              <colgroup><col width="200px"/><col width=""/></colgroup>
              <tbody>
              <tr><th>부모 클래스/ID</th><td>
                <InputGroup><FormInput name="parentSelector" value={this.metaWidget.reviewRatingCountConfig.parentSelector || ''} onChange={this.onChangeReviewRatingCountConfig} placeholder=".class-name 또는 #element-id" /></InputGroup>
              </td></tr>
              <tr><th>위젯 삽입 위치</th><td>
                <FormSelect name="insertPosition" value={this.metaWidget.reviewRatingCountConfig.insertPosition || 'append'} onChange={this.onChangeReviewRatingCountConfig}>
                  <option value="append">지정 요소 내부의 맨 끝에 추가</option><option value="prepend">지정 요소 내부의 맨 앞에 추가</option>
                  <option value="after">지정 요소 바로 뒤에 추가 (형제 요소)</option><option value="before">지정 요소 바로 앞에 추가 (형제 요소)</option>
                  <option value="html">지정 요소의 내용을 대체</option>
                </FormSelect>
              </td></tr>
              <tr><th>위젯 최대너비</th><td><InputGroup><FormInput name="maxWidth" value={this.metaWidget.reviewRatingCountConfig.maxWidth} onChange={this.onChangeReviewRatingCountConfig} /></InputGroup></td></tr>
              <tr><th>상단여백</th><td><InputGroup><FormInput name="marginTop" value={this.metaWidget.reviewRatingCountConfig.marginTop} onChange={this.onChangeReviewRatingCountConfig} /></InputGroup></td></tr>
              <tr><th>하단여백</th><td><InputGroup><FormInput name="marginBottom" value={this.metaWidget.reviewRatingCountConfig.marginBottom} onChange={this.onChangeReviewRatingCountConfig} /></InputGroup></td></tr>
              <tr><th>좌우여백</th><td><InputGroup><FormInput name="lrPadding" value={this.metaWidget.reviewRatingCountConfig.lrPadding} onChange={this.onChangeReviewRatingCountConfig} /></InputGroup></td></tr>
              </tbody>
            </table>
            <div className="btn-save" style={{marginTop:'20px',textAlign:'right'}}><Button className="save-button" onClick={this.saveReviewRatingCountConfig}>저장</Button></div>
          </ModalBody>
        </Modal>

        {/* 리뷰 페이지 세부 설정 모달 */}
        <Modal className='isReviewPageSetting' open={this.modals.isReviewPageSetting} toggle={() => {}} size="lg">
          <ModalHeader toggle={() => this.metaModalToggle('isReviewPageSetting')}>리뷰 페이지 세부 설정</ModalHeader>
          <ModalBody>
            <table className="modal-table">
              <colgroup><col width="200px"/><col width=""/></colgroup>
              <tbody>
              <tr><th>부모 클래스/ID</th><td>
                <InputGroup><FormInput name="parentSelector" value={this.metaWidget.reviewPageConfig.parentSelector} onChange={this.onChangeReviewPageConfig} placeholder=".class-name 또는 #element-id" /></InputGroup>
              </td></tr>
              <tr><th>위젯 삽입 위치</th><td>
                <FormSelect name="insertPosition" value={this.metaWidget.reviewPageConfig.insertPosition} onChange={this.onChangeReviewPageConfig}>
                  <option value="append">지정 요소 내부의 맨 끝에 추가</option><option value="prepend">지정 요소 내부의 맨 앞에 추가</option>
                  <option value="after">지정 요소 바로 뒤에 추가 (형제 요소)</option><option value="before">지정 요소 바로 앞에 추가 (형제 요소)</option>
                  <option value="html">지정 요소의 내용을 대체</option>
                </FormSelect>
              </td></tr>
              <tr><th>위젯 최대너비</th><td><InputGroup><FormInput name="maxWidth" value={this.metaWidget.reviewPageConfig.maxWidth} onChange={this.onChangeReviewPageConfig} /></InputGroup></td></tr>
              <tr><th>상단여백</th><td><InputGroup><FormInput name="marginTop" value={this.metaWidget.reviewPageConfig.marginTop} onChange={this.onChangeReviewPageConfig} /></InputGroup></td></tr>
              <tr><th>하단여백</th><td><InputGroup><FormInput name="marginBottom" value={this.metaWidget.reviewPageConfig.marginBottom} onChange={this.onChangeReviewPageConfig} /></InputGroup></td></tr>
              <tr><th>좌우여백</th><td><InputGroup><FormInput name="lrPadding" value={this.metaWidget.reviewPageConfig.lrPadding} onChange={this.onChangeReviewPageConfig} /></InputGroup></td></tr>
              <tr>
                <th>숨김 처리할 클래스/ID</th>
                <td>
                  <FormInput name="hideSelector"
                             value={this.metaWidget.reviewPageConfig.hideSelector || ''}
                             onChange={this.onChangeReviewPageConfig}
                             placeholder=".class1, #id1, .class2"/>
                  <p style={{marginTop: 5, fontSize: 12, color: '#666'}}>
                    리뷰 게시판 페이지에서 <b>숨기고 싶은 요소</b>의 CSS selector를 입력합니다. 쉼표(,)로 여러 개 지정할 수 있습니다.<br/>
                    예: <code>.xans-board-listpackage</code>, <code>#board-header</code>, <code>.original-review-area</code>
                  </p>
                </td>
              </tr>
              </tbody>
            </table>
            <div className="btn-save" style={{marginTop:'20px',textAlign:'right'}}><Button className="save-button" onClick={this.saveReviewPageConfig}>저장</Button></div>
          </ModalBody>
        </Modal>

        {/* 실시간 리뷰 위젯 세부 설정 모달 */}
        <Modal className='isRealtimeReviewSetting' open={this.modals.isRealtimeReviewSetting} toggle={() => {}} size="lg">
          <ModalHeader toggle={() => this.metaModalToggle('isRealtimeReviewSetting')}>실시간 리뷰 위젯 세부 설정</ModalHeader>
          <ModalBody>
            <table className="modal-table">
              <colgroup><col width="200px"/><col width=""/></colgroup>
              <tbody>
              <tr><th>부모 클래스/ID</th><td>
                <InputGroup><FormInput name="parentSelector" value={this.metaWidget.realtimeReviewConfig.parentSelector || ''} onChange={this.onChangeRealtimeReviewConfig} placeholder=".class-name 또는 #element-id" /></InputGroup>
                <p style={{marginTop:'5px',fontSize:'12px',color:'#666'}}>예: .review-container, #review-wrap</p>
              </td></tr>
              <tr><th>위젯 삽입 위치</th><td>
                <FormSelect name="insertPosition" value={this.metaWidget.realtimeReviewConfig.insertPosition || 'append'} onChange={this.onChangeRealtimeReviewConfig}>
                  <option value="append">지정 요소 내부의 맨 끝에 추가</option><option value="prepend">지정 요소 내부의 맨 앞에 추가</option>
                  <option value="after">지정 요소 바로 뒤에 추가 (형제 요소)</option><option value="before">지정 요소 바로 앞에 추가 (형제 요소)</option>
                  <option value="html">지정 요소의 내용을 대체</option>
                </FormSelect>
              </td></tr>
              </tbody>
            </table>
            <div className="btn-save" style={{marginTop:'20px',textAlign:'right'}}><Button className="save-button" onClick={this.saveRealtimeReviewConfig}>저장</Button></div>
          </ModalBody>
        </Modal>

        <Modal size="lg" className='isNewWidget' open={this.modals.isNewWidget} toggle={() => {}}
               centered={true}>
          <ModalHeader>
            위젯 만들기
            <Button className="btn-modal-close" theme="secondary" size="sm" type='button'
                    onClick={event => this.modals.isNewWidget = false} >
              <FeatherIcon icon="x" className="nd-icon" />
            </Button>
          </ModalHeader>
          <ModalBody>
            <div>
              <table>
                <colgroup>
                  <col style={{ width: '15%' }} />
                  <col />
                </colgroup>
                <tbody>
                {this.makeWidgetProps ?
                    <tr>
                      <th>종류</th>
                      <td>
                        <FormSelect name="type" value={this.newWidget.type} onChange={event => {
                          this.onChangeValue(event, this.newWidget)
                        }}>
                          {
                            Object.keys(this.makeWidgetProps).map((key, i) => (
                                <option key={key} value={key}>{this.makeWidgetProps[key].label}</option>
                            ))
                          }
                        </FormSelect>
                      </td>
                    </tr>
                    : null
                }
                <tr>
                  <th>타이틀</th>
                  <td>
                    <FormInput name="title" placeholder="제목" value={this.newWidget.title} onChange={event => {
                      this.onChangeValue(event, this.newWidget)
                    }}/>
                  </td>
                </tr>
                <tr>
                  <th>타이틀 노출</th>
                  <td>
                    <FormSelect name="isTitleDis" value={this.newWidget.isTitleDis} onChange={event => {
                      this.onChangeValue(event, this.newWidget)
                    }}>
                      {
                        this.newWidgetProps.isTitleDis.map((item, key) => (
                            <option key={key} value={item.key}>{item.label}</option>
                        ))
                      }
                    </FormSelect>
                  </td>
                </tr>
                {this.newWidgetProps && this.newWidgetProps.selecting ?
                    <tr>
                      <th>리뷰 선택</th>
                      <td>
                        <FormSelect name="selecting" value={this.newWidget.selecting} onChange={event => {
                          this.onChangeValue(event, this.newWidget)
                        }}>
                          {
                            this.newWidgetProps.selecting.map((item, key) => (
                                <option key={key} value={item.key}>{item.label}</option>
                            ))
                          }
                        </FormSelect>
                      </td>
                    </tr>
                    : null
                }
                {this.newWidgetProps && this.newWidgetProps.reviewType ?
                    <tr>
                      <th>리뷰 타입</th>
                      <td>
                        <FormSelect name="reviewType" value={this.newWidget.reviewType} onChange={event => {
                          this.onChangeValue(event, this.newWidget)
                        }}>
                          {
                            this.newWidgetProps.reviewType.map((item, key) => (
                                <option key={key} value={item.key}>{item.label}</option>
                            ))
                          }
                        </FormSelect>
                      </td>
                    </tr>
                    : null
                }
                {this.newWidgetProps && this.newWidgetProps.displayArea ?
                    <tr>
                      <th>노출 영역</th>
                      <td>
                        <FormSelect name="displayArea" value={this.newWidget.displayArea} onChange={event => {
                          this.onChangeValue(event, this.newWidget)
                        }}>
                          {
                            this.newWidgetProps.displayArea.map((item, key) => (
                                <option key={key} value={item.key}>{item.label}</option>
                            ))
                          }
                        </FormSelect>
                      </td>
                    </tr>
                    : null
                }
                {this.newWidgetProps && this.newWidgetProps.col ?
                    <tr>
                      <th>라인당 리뷰수</th>
                      <td>
                        <FormSelect name="col" value={this.newWidget.col} onChange={event => {
                          this.onChangeValue(event, this.newWidget)
                        }}>
                          {
                            this.newWidgetProps.col.map((item, key) => (
                                <option key={key} value={item.key}>{item.label}</option>
                            ))
                          }
                        </FormSelect>
                      </td>
                    </tr>
                    : null
                }
                {this.newWidgetProps && this.newWidgetProps.row ?
                    <tr>
                      <th>라인 수</th>
                      <td>
                        <FormSelect name="row" value={this.newWidget.row} onChange={event => {
                          this.onChangeValue(event, this.newWidget)
                        }}>
                          {
                            this.newWidgetProps.row.map((item, key) => (
                                <option key={key} value={item.key}>{item.label}</option>
                            ))
                          }
                        </FormSelect>
                      </td>
                    </tr>
                    : null
                }
                {this.newWidgetProps && this.newWidgetProps.isAutoPlay && this.newWidget.type === "slider" ?
                    <tr>
                      <th>자동 슬라이드</th>
                      <td>
                        <FormSelect name="isAutoPlay" value={this.newWidget.isAutoPlay} onChange={event => {
                          this.onChangeValue(event, this.newWidget)
                        }}>
                          {
                            this.newWidgetProps.isAutoPlay.map((item, key) => (
                                <option key={key} value={item.key}>{item.label}</option>
                            ))
                          }
                        </FormSelect>
                      </td>
                    </tr>
                    : null
                }
                {this.newWidgetProps && this.newWidgetProps.isDisplay ?
                    <tr>
                      <th>노출 여부</th>
                      <td>
                        <FormSelect name="isDisplay" value={this.newWidget.isDisplay} onChange={event => {
                          this.onChangeValue(event, this.newWidget)
                        }}>
                          {
                            this.newWidgetProps.isDisplay.map((item, key) => (
                                <option key={key} value={item.key}>{item.label}</option>
                            ))
                          }
                        </FormSelect>
                      </td>
                    </tr>
                    : null
                }
                </tbody>
              </table>
            </div>
            <div className="popup-close text-center mt-3">
              <Button type='button' onClick={event => this.updateWidget()}>저장</Button>
            </div>

          </ModalBody>
        </Modal>

        <Modal size="lg" className='isWidgetHeadSetiing' open={this.modals.isWidgetHeadSetiing} toggle={() => {}} centered={true} style={{maxHeight: '90vh'}}>
          <ModalHeader>
            위젯 세부 설정
            <Button className="btn-modal-close" theme="secondary" size="sm" type='button' onClick={event=> this.modals.isWidgetHeadSetiing = false} >
              <FeatherIcon icon="x" className="nd-icon" />
            </Button>
          </ModalHeader>
          <ModalBody style={{maxHeight: 'calc(90vh - 60px)', overflowY: 'auto'}}>
            <div>
              <table>
                <colgroup>
                  <col style={{ width: '25%' }} />
                  <col />
                </colgroup>
                <tbody>
                <tr>
                  <th>위젯 이름</th>
                  <td>
                    <FormInput name="title" placeholder="제목" value={this.curWidget.title} onChange={event => {
                      this.onChangeValue(event, this.curWidget)
                    }}/>
                  </td>
                </tr>
                <tr>
                  <th>부모 클래스/ID</th>
                  <td>
                    <InputGroup>
                      <FormInput
                          name="parentSelector"
                          value={this.curWidget.style.parentSelector || ''}
                          onChange={event => {
                            this.onChangeValue(event, this.curWidget.style)
                          }}
                          placeholder=".class-name 또는 #element-id"
                      />
                    </InputGroup>
                    <p style={{ marginTop: '5px', fontSize: '12px', color: '#666' }}>
                      예: .review-container, #review-wrap
                    </p>
                  </td>
                </tr>
                <tr>
                  <th>위젯 삽입 위치</th>
                  <td>
                    <FormSelect
                        name="insertPosition"
                        value={this.curWidget.style.insertPosition || 'append'}
                        onChange={event => {
                          this.onChangeValue(event, this.curWidget.style)
                        }}
                    >
                      <option value="append">지정 요소 내부의 맨 끝에 추가</option>
                      <option value="prepend">지정 요소 내부의 맨 앞에 추가</option>
                      <option value="after">지정 요소 바로 뒤에 추가 (형제 요소)</option>
                      <option value="before">지정 요소 바로 앞에 추가 (형제 요소)</option>
                      <option value="html">지정 요소의 내용을 대체</option>
                    </FormSelect>
                    <p style={{ marginTop: '5px', fontSize: '12px', color: '#666' }}>
                      부모 클래스/ID로 지정한 요소를 기준으로 위젯이 삽입될 위치를 선택합니다.
                    </p>
                  </td>
                </tr>
                <tr>
                  <th>위젯 최대 너비</th>
                  <td>
                    <InputGroup className="mb-2">
                      <FormInput name="maxWidth" value={this.curWidget.style.maxWidth}
                                 placeholder="기본값은 100%입니다.(비율로 입력시 %를 붙여주세요.)" onChange={event => {
                        this.onChangeValue(event, this.curWidget.style)
                      }}/>
                      <InputGroupAddon type="append">
                        <InputGroupText>PX(%)</InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                  </td>
                </tr>
                <tr>
                  <th>상단 여백</th>
                  <td>
                    <InputGroup className="mb-2">
                      <FormInput name="marginTop" value={this.curWidget.style.marginTop}
                                 placeholder="기본값은 30px입니다." onChange={event => {
                        this.onChangeValue(event, this.curWidget.style)
                      }}/>
                      <InputGroupAddon type="append">
                        <InputGroupText>PX</InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                  </td>
                </tr>

                <tr>
                  <th>하단 여백</th>
                  <td>
                    <InputGroup className="mb-2">
                      <FormInput name="marginBottom" value={this.curWidget.style.marginBottom}
                                 placeholder="기본값은 30px입니다." onChange={event => {
                        this.onChangeValue(event, this.curWidget.style)
                      }}/>
                      <InputGroupAddon type="append">
                        <InputGroupText>PX</InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                  </td>
                </tr>
                <tr>
                  <th>타이틀</th>
                  <td>
                    <FormInput name="title" placeholder="타이틀" value={this.curWidget.head.title} onChange={event => {
                      this.onChangeValue(event, this.curWidget.head)
                    }}/>
                  </td>
                </tr>
                <tr>
                  <th>타이틀 노출 여부</th>
                  <td>
                    <FormSelect name="isTitleDis" value={this.curWidget.isTitleDis} onChange={event => {
                      this.onChangeValue(event, this.curWidget)
                    }}>
                      <option value={true}>노출함</option>
                      <option value={false}>노출안함</option>
                    </FormSelect>
                  </td>
                </tr>

                <tr>
                  <th>타이틀 텍스트 정렬</th>
                  <td>
                    <FormSelect name="textAlign" className="search-type" value={this.curWidget.head.style.textAlign}
                                onChange={event => {
                                  this.onChangeValue(event, this.curWidget.head.style)
                                }}>
                      <option value="">-정렬 선택하기-</option>
                      <option value="left">왼쪽 정렬</option>
                      <option value="center">가운데 정렬</option>
                      <option value="right">오른쪽 정렬</option>
                    </FormSelect>
                  </td>
                </tr>
                <tr>
                  <th>타이틀 폰트 크기</th>
                  <td>
                    <InputGroup className="mb-2">
                      <FormInput name="size" value={this.curWidget.head.style.size} placeholder="기본값은 23px입니다."
                                 onChange={event => {
                                   this.onChangeValue(event, this.curWidget.head.style)
                                 }}/>
                      <InputGroupAddon type="append">
                        <InputGroupText>PX</InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                  </td>
                </tr>
                <tr>
                  <th>타이틀 폰트 색</th>
                  <td>
                    <div className="color-picker">
                      {this.isShowMColor_1 ? (
                          <div className="color-picker-selecter-wrap"
                               onMouseLeave={event => this.isShowMColor_1 = false}>
                            <ChromePicker
                                name="color"
                                disableAlpha={true}
                                color={this.curWidget.head.style.color}
                                onChangeComplete={(color) => {
                                  this.onChangeColor('color', color, this.curWidget.head.style)
                                }}
                            />
                          </div>) : null}
                      <InputGroup>
                        <InputGroupAddon type="append">
                          <InputGroupText onClick={event => {
                            _this.showColorModalFn('isShowMColor_1');
                          }} style={{backgroundColor: this.curWidget.head.style.color}}>
                            <FeatherIcon icon="droplet" size="15" style={{color: "#ffffff"}}/>
                          </InputGroupText>
                        </InputGroupAddon>
                        <FormInput value={this.curWidget.head.style.color} placeholder="색상값을 입력해 주세요." readOnly={true}
                                   onClick={event => {
                                     _this.showColorModalFn('isShowMColor_1');
                                   }}/>
                      </InputGroup>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>타이틀과 리뷰 리스트 간격</th>
                  <td>
                    <InputGroup className="mb-2">
                      <FormInput name="marginBottom" value={this.curWidget.head.style.marginBottom}
                                 placeholder="기본값은 30px입니다." onChange={event => {
                        this.onChangeValue(event, this.curWidget.head.style)
                      }}/>
                      <InputGroupAddon type="append">
                        <InputGroupText>PX</InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                  </td>
                </tr>
                <tr>
                  <th>타이틀 좌우 여백</th>
                  <td>
                    <InputGroup className="mb-2">
                      <FormInput name="lrPadding" value={this.curWidget.head.style.lrPadding}
                                 placeholder="기본값은 0px입니다." onChange={event => {
                        this.onChangeValue(event, this.curWidget.head.style)
                      }}/>
                      <InputGroupAddon type="append">
                        <InputGroupText>PX</InputGroupText>/
                      </InputGroupAddon>
                    </InputGroup>
                  </td>
                </tr>
                <tr>
                  <th>서브 타이틀(설명)</th>
                  <td>
                    <FormInput name="subtitle" placeholder="서브 타이틀 또는 설명을 입력하세요" value={this.curWidget.head.subtitle || ''} onChange={event => {
                      this.onChangeValue(event, this.curWidget.head)
                    }}/>
                    <small className="text-muted">타이틀 아래에 표시되는 부가 설명입니다.</small>
                  </td>
                </tr>
                <tr>
                  <th>리뷰 평점 / 카운트 노출</th>
                  <td>
                    <label><input onChange={event => {
                      this.onChangeValue(event, this.curWidget.display)
                    }} value={Boolean(this.curWidget.display.rating)}
                                                                 checked={Boolean(this.curWidget.display.rating)}
                                                                 name="rating"
                                                                 type="checkbox"/><span>&nbsp;평점</span></label>
                    <label className="ml-3"><input onChange={event => {
                      this.onChangeValue(event, this.curWidget.display)
                    }} value={Boolean(this.curWidget.display.count)}
                                                                 checked={Boolean(this.curWidget.display.count)}
                                                                 name="count"
                                                                 type="checkbox"/><span>&nbsp;카운트</span></label>
                  </td>
                </tr>
                <tr>
                  <th>슬라이드 전환 속도</th>
                  <td>
                    <InputGroup className="mb-2">
                      <FormInput name="slideDelay" value={this.curWidget.slideDelay || 3000}
                                 placeholder="기본값은 300ms입니다." onChange={event => {
                        this.onChangeValue(event, this.curWidget)
                      }}/>
                      <InputGroupAddon type="append">
                        <InputGroupText>ms</InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                    <small className="text-muted">슬라이드 전환 딜레이 시간 (밀리초 - ex 3000 -> 3초)</small>
                  </td>
                </tr>
                <tr>
                  <th>이동 슬라이드 수</th>
                  <td>
                    <FormSelect name="slidesToScroll" value={this.curWidget.slidesToScroll || 1} onChange={event => {
                      this.onChangeValue(event, this.curWidget)
                    }}>
                      <option value={1}>1개씩</option>
                      <option value={2}>2개씩</option>
                      <option value={3}>3개씩</option>
                      <option value={4}>4개씩</option>
                      <option value={5}>5개씩</option>
                    </FormSelect>
                    <small className="text-muted">한 번에 이동할 슬라이드 개수</small>
                  </td>
                </tr>
                <tr>
                  <th>모바일 슬라이드 노출수</th>
                  <td>
                    <FormSelect name="mobileSlidesPerView" value={this.curWidget.mobileSlidesPerView || 2} onChange={event => {
                      this.onChangeValue(event, this.curWidget)
                    }}>
                      <option value={1}>1개</option>
                      <option value={2}>2개</option>
                      <option value={3}>3개</option>
                      <option value={4}>4개</option>
                      <option value={5}>5개</option>
                    </FormSelect>
                    <small className="text-muted">모바일에서 한 화면에 표시할 슬라이드 개수</small>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div className="popup-close text-center mt-3">
              <Button type='button' onClick={event => this.onChangeStyleValue(this.curWidget)}>저장</Button>
            </div>

          </ModalBody>
        </Modal>

        {/* 위젯 예제 라이트박스 — 박스 헤더의 "예제 보기" 버튼 클릭 시 표시 */}
        <PreviewLightbox
          open={!!this.previewSample}
          src={this.previewSample && this.WIDGET_SAMPLES[this.previewSample] ? this.WIDGET_SAMPLES[this.previewSample].src : null}
          caption={this.previewSample && this.WIDGET_SAMPLES[this.previewSample] ? this.WIDGET_SAMPLES[this.previewSample].caption : ''}
          onClose={this.closePreviewSample}
        />

      </div>
    )
  }
}

export default widgetByPage;
